<ngx-spinner bdColor="rgba(10, 10, 10, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
<div class="content-wrapper">
  <div id="wrapper1">
    <div class="main-body-layout">
      <div style="display: flex; justify-content: space-between;" class="styleClass">
        <a (click)="ReturnHome(1)">
          <img mat-card-image src="assets/images/O3_Sigma_White.png" width="60px" height="" style="width:9rem">
        </a>
        <h1 style="color:#fff;text-align: left;">Machine: {{machineName}}</h1>
        <h1 *ngIf="downTimeStarted" style="color:#fff;text-align: left;">Machine Status: <span
            style="color:red">Down</span></h1>
        <h1 *ngIf="!downTimeStarted" style="color:#fff;text-align: left;">Machine Status: <span
            style="color:green">Running</span></h1>
        <span id="timer" class="show-timer hide-timer"><label> {{langObj ? langObj?.DownTime : ('DownTime' |
            translate)}}</label>&#58;<span class="show-timer hide-timer"
            style="color:#ff0000;font-weight: 100;margin-left: 5px;"> {{timer}} </span>
          <div><label>Fault:<span
                style="color:white;font-weight: 100;margin-left: 5px;">{{selectedFault}}</span></label></div>
        </span>
        <div style="display: flex; justify-content: flex-end; align-items: center;">
          <button mat-raised-button color="accent" (click)="ReturnHome(1)" style=" margin-right: 10px;">
            <mat-icon style="color: #fff;">home</mat-icon>
          </button>
          <form [formGroup]="translateForm">
            <mat-select class="form-control select-item"
              style="width: 100px; background-color: #000; text-align: center; padding: 12px; margin-right: 10px;"
              #selectedLang formControlName="languagvalue"
              (selectionChange)="translater.switchLang(selectedLang.value)">
              <mat-option *ngFor="let language of translater.translate.getLangs()" [value]="language">
                {{ language }}
              </mat-option>
            </mat-select>
          </form>
          <img class="opeartor_image" [src]="userImage ? userProfileImg : '../../../assets/images/img_avatar.png'"
            alt="Operator Profile"
            (click)="ProfileImageZoom( userImage ? userProfileImg : '../../../assets/images/img_avatar.png')">
          <span [matMenuTriggerFor]="menu" class="operator_text">{{operatorName}}</span>
          <mat-menu #menu="matMenu">
            <button mat-menu-item>
              <span>{{operatorName}}</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <span>Sign Out</span>
            </button>
          </mat-menu>
        </div>
      </div>

      <div style=" align-items: center; justify-content: center; margin-top: 15px;">
        <div class="fields_wrapper">
          <div class="p-md-12 p-sm-12">
            <div id="container"></div>
          </div>
        </div>
        <form [formGroup]="groupDataForm">
          <div class="top_fields_wrapper ">
            <div class="p-lg-2 p-md-4 p-sm-12">
              <div class="sfdc_responsive content-top-row">
                <input formControlName="Id" [hidden]="true">

                <mat-form-field
                  class="text-fields content_res top-row-first-filed-item top-row-first-filed-item-order-processing select-item"
                  style="width: 100% !important;">
                  <mat-label class="placeholder-title">{{langObj ? langObj?.SelectGroup : ('SelectGroup' | translate)}}
                  </mat-label>
                  <input matInput formControlName="group" name="group" [readonly]="true" />
                </mat-form-field>
              </div>
            </div>
            <div class="p-lg-2 p-md-4 p-sm-12">
              <div class="sfdc_responsive content-top-row">
                <mat-form-field
                  class="text-fields content_res top-row-first-filed-item top-row-first-filed-item-order-processing select-item"
                  style="width: 100% !important;">
                  <mat-label class="placeholder-title">{{langObj ? langObj?.Plant : ('Plant' | translate)}}
                  </mat-label>
                  <input matInput formControlName="plant" name="plant" [readonly]="true" />
                </mat-form-field>
              </div>
            </div>
            <div class="p-lg-2 p-md-4 p-sm-12">
              <div class="sfdc_responsive content-top-row">
                <mat-form-field style="width: 100% !important;"
                  class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing select-item">
                  <mat-label>{{langObj ? ('Line' | translate) : ('Line' | translate)}}</mat-label>
                  <mat-select panelClass="testClass" name="Line" formControlName="line"
                    (selectionChange)="onChangeLine($event)" required>
                    <mat-option *ngFor="let line of Lines" [value]="line.PL_Id">
                      {{ line.PL_Desc }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="p-lg-2 p-md-4 p-sm-12">
              <div class="sfdc_responsive content-top-row">
                <mat-form-field style="width: 100% !important;"
                  class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing select-item">
                  <mat-label class="placeholder-title">{{langObj ? langObj?.Machine : ('Machine' | translate)}}
                  </mat-label>
                  <mat-select (selectionChange)="SelectUnitName()" panelClass="testClass" name="Machine"
                    formControlName="machine">
                    <mat-option *ngFor="let machine of Machines" [value]="machine.unitId">
                      {{ machine.unitDesc }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="p-lg-2 p-md-4 p-sm-12">
              <form [formGroup]="checklistDataForm">
                <div class="sfdc_responsive content-top-row">
                  <mat-form-field
                    class="text-fields content_res top-row-first-filed-item top-row-first-filed-item-order-processing select-item"
                    style="width: 100% !important;">
                    <mat-label class="sfdc-label shiftPadding">{{langObj ? langObj?.Shift : ('Shift' | translate)}}
                    </mat-label>
                    <input matInput formControlName="shiftName" name="shiftName" [readonly]="true" />
                  </mat-form-field>
                </div>
              </form>
            </div>
            <div class="p-lg-2 p-md-4 p-sm-12">
              <form [formGroup]="checklistDataForm">
                <div class="sfdc_responsive content-top-row">
                  <mat-form-field
                    class="text-fields content_res top-row-first-filed-item top-row-first-filed-item-order-processing select-item"
                    style="width: 100% !important;">
                    <mat-label class="sfdc-label">{{'Date' | translate}}</mat-label>
                    <input matInput formControlName="date" name="date" [tooltipPosition]="'top'"
                      [pTooltip]="this.shiftstart | date : 'medium'" [readonly]="true"
                      [ngModel]="rxTime | date: 'medium'" />
                  </mat-form-field>
                </div>
              </form>
            </div>
          </div>
        </form>

        <div class="fields_wrapper" style="flex-wrap: wrap;">
          <div class="p-lg-4 p-md-6 p-sm-12 d-flex justify-content-between">
            <div class="downtime_timer">
              <button *ngIf="isChangeOverCheckListShow" (click)="openChangeOverCheckListModel()" mat-raised-button
                style="height: fit-content;" color="accent" class="btn_res">
                Change Over</button>

            </div>
            <div class="d-flex">
              <span class="status_type"
                (onChange)="groupDataMode ? SumbitProcessOrderStatus() : SumbitProcessOrderStatus()" type="submit"
                [style.color]="StatusColor"><label *ngIf="materialConsumptionMode" class="status_label">PO Status &#58;
                </label>{{statusPo}}</span>
            </div>
          </div>

          <div class="p-lg-4 p-md-6 p-sm-12">
            <div class="d-flex justify-between mid-flex-button-wrapper fixed button_width">
              <button id="startbtn" [disabled]="startbutton" (click)="start()" mat-raised-button color="accent"
                class="btn_res">
                {{langObj ? langObj?.Start : ('Start' | translate)}}</button>

              <button id="pausebtn" [disabled]="pausebutton" (click)="pause()" mat-raised-button
                style=" background-color: #dfee0f;" color="accent" class="btn_res">
                {{'Pause' | translate}}</button>

              <button id="closebtn" [disabled]="closebutton" (click)="close()" *ngIf="IsWrite" mat-raised-button
                color="accent" class="btn_res">
                {{'Complete' | translate}}</button>
            </div>
          </div>
          <div class="p-lg-4 p-md-12 p-sm-12 mid_button_wrapper ">
            <div class="d-flex justify-between mid-flex-button-wrapper fixed button_width">
              <button *ngIf="showButtons" (click)="openPoModal()" mat-raised-button style="height: fit-content;"
                color="accent" class="btn_res">
                {{langObj ? langObj?.PoList : ('PoList' | translate)}}</button>

              <button *ngIf="showButtons" (click)="GetLastShiftInfo($event)" mat-raised-button
                style="height: fit-content;" color="accent" class="btn_res">
                {{ langObj ? langObj?.LastShift : ('LastShift' | translate)}}</button>

              <button *ngIf="showShiftClose" (click)="openshiftcloseModal()" mat-raised-button
                style="height: fit-content; " color="accent" class="btn_res">
                {{ langObj ? langObj?.ShiftClose : ('ShiftClose' | translate)}}</button>
            </div>
          </div>
        </div>


        <div class="fields_wrapper">
          <div class="p-md-4 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{ langObj ? langObj?.ItemCode : ('ItemCode' | translate)}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="itemCodePo" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-4 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label shiftPadding">{{ langObj ? langObj?.ItemDescription : ('ItemDescription' |
                translate)}}
              </mat-label>
              <input matInput [(ngModel)]="itemDescPo" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-4 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Production Order'|translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="poprocessOrder" [readonly]="true">
            </mat-form-field>
          </div>
        </div>

        <div class="fields_wrapper">
          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'OEE' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_OEE " [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Availability' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_Availability" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Gross Produced' | translate}} {{Result}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_TotalProducedQTy" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Net Produced' | translate}} {{Result}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_TotalGoodPieces" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Planned Quantity' | translate}} {{Result}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="targetQty" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Remaining Quantity' | translate}} {{Result}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="remainingQty" [readonly]="true">
            </mat-form-field>
          </div>
        </div>
        <div class="fields_wrapper">
          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Performance' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_Performance" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Quality' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_Quality" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Total waste' | translate}} {{resultWaste}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_Totalwaste" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Shift Downtime (Mins)' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_TotalDowntime" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Average Speed' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="SFDC_TotalAverageSpeed" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-2 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Remaining Time' | translate}}</mat-label>
              <input matInput class="text-fields-bottom" [(ngModel)]="calculatedremainingtime" [readonly]="true">
            </mat-form-field>
          </div>

        </div>

        <div class="fields_wrapper">
          <div class="p-md-4 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Shift Waste' | translate}}</mat-label>
              <input matInput [(ngModel)]="shiftWiseWaste" class="text-fields-bottom" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-4 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label shiftPadding">{{'Shift Gross Produced'|
                translate}}
              </mat-label>
              <input matInput [(ngModel)]="shiftWiseGrossProduced" [readonly]="true">
            </mat-form-field>
          </div>

          <div class="p-md-4 p-sm-12">
            <mat-form-field appearence="fill"
              class="text-fields width content content_res top-row-first-filed-item top-row-first-filed-item-order-processing  select-item">
              <mat-label class="sfdc-label">{{'Shift Net Produced'|translate}}</mat-label>
              <input matInput [(ngModel)]="shiftWiseNetProduced" class="text-fields-bottom" [readonly]="true">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="d-flex justify-between flex-button-wrapper fixed button_width" style="padding-top: 10px;">
        <button id="MaterialConsumption" (click)="onPrevious1()" mat-raised-button [disabled]="disableSFDCbuttons"
          color="warn" class="btn_res">
          {{langObj ? langObj?.MaterialConsumption : ('Material Consumption' | translate)}}</button>
        <button id="ProductionOutput" (click)="onPrevious2()" mat-raised-button [disabled]="disableSFDCbuttons"
          color="warn" class="btn_res">
          {{langObj ? langObj?.ProductionOutput : ('Production Output' | translate)}}</button>
        <button id="ProcessControl" (click)="onPrevious3()" mat-raised-button [disabled]="disableSFDCbuttons"
          color="warn" class="btn_res">
          {{langObj ? langObj?.ProcessControl : ('Process Control' | translate)}}</button>
        <button id="Waste" (click)="onPrevious4()" mat-raised-button [disabled]="disableSFDCbuttons" color="accent"
          class="btn_res">
          {{langObj ? langObj?.Waste : ('Waste' | translate)}}</button>
        <button id="downTimerPrevious" (click)="onPrevious5()" mat-raised-button [disabled]="disableSFDCbuttons"
          color="accent" class="btn_res">
          {{langObj ? langObj?.DownTime : ('DownTime' | translate)}}</button>
        <button id="QualityControl" (click)="onPrevious6()" mat-raised-button [disabled]="disableSFDCbuttons"
          color="accent" class="btn_res">
          {{langObj ? langObj?.QualityControl : ('Quality Control' | translate)}}</button>
        <button id="ChecklistExecution" (click)="onPrevious7()" mat-raised-button [disabled]="disableSFDCbuttons"
          color="warn" class="btn_res">
          {{'ChecklistExecution' | translate}}</button>
      </div>

    </div>

  </div>
  <!-- Material Consumption -->
  <div id="wrapper2">
    <div class="table-wrapper">
      <div class="title">
        <h1>{{'MaterialConsumption' | translate}}<span>{{selectedunit}}</span></h1>
        <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
          (click)="onPrevious8()">Previous</button>
      </div>
    </div>
    <form class="table-wrapper" [formGroup]="materialConsumptionForm" *ngIf="!isFoodSector">
      <div class="table-wrapper">



        <div class="content-top-row content Quality_sfdc_responsive">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 1px;">
            <input formControlName="Id" [hidden]="true">
            <mat-label>{{ langObj ? langObj?.MaterialDetail : ('MaterialDetail')}}</mat-label>
            <mat-select formControlName="materialDate" panelClass="testClass" name="materialDate"
              (selectionChange)="GetLableBatch($event)">
              <mat-option *ngFor="let material of ItemTypeList" [value]="material.BatchItemTypeId"> {{material.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="inputField date_sfdc">
            <nz-date-picker class="calender-input sfdcCalender-input" id="timePicker" formControlName="date"
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true">
            </nz-date-picker>
            <span style="color: white;opacity: initial;" class="floating-text">{{'Time' | translate}}</span>
          </div>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{'LotCodeOrDetail' | translate}}</mat-label>
            <input formControlName="lot" matInput name="batchdesc" autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{'ActualQuantity' | translate}} {{result}}</mat-label>
            <input formControlName="actQty" type="number" matInput name="length" required autocomplete="off" />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{'EstimatedQuantity' | translate}} {{result}}</mat-label>
            <input formControlName="qty" matInput name="qty" [readonly]="true" required autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="content-top-row content Quality_sfdc_responsive">
          <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after" matBadgeColor="accent"
            MatBadgeSize="large" disableRipple>
            {{itemCode}}
          </button>
          <button class="user_badge" mat-flat-button color="#22bef2" matBadgePosition="after" matBadgeColor="accent"
            MatBadgeSize="large" disableRipple style="margin-left: 14px;"
            [class]="languageDir === 'rtl' ? 'arb-btn-mrgn' : ''">
            {{total}}
          </button>
          <mat-form-field appearence="outline"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="margin-left: 14px;">
            <mat-label>{{'Remarks' | translate}}</mat-label>
            <input formControlName="remarks" matInput name="remarks" />
          </mat-form-field>
        </div>
        <div class="content-top-row content Quality_sfdc_responsive"
          style="margin-top: 20px; display: flex; justify-content: flex-end;">

          <div>
            <button (click)="UpdateJBBatchInfoForMaterialConsumption()" type="submit"
              *ngIf="!materialConsumptionMode && IsWrite" [disabled]="!materialConsumptionForm.valid" mat-raised-button
              color="primary" [pTooltip]="'Update' | translate" tooltipPosition="top">
              <i class="fa fa-pencil" style="color: #fff"></i>
            </button>
            <button (click)="SaveJBBatchInfoForMaterialConsumption()" type="submit" [disabled]="disablMaterialSave"
              *ngIf="materialConsumptionMode && IsWrite" [disabled]="!materialConsumptionForm.valid" mat-raised-button
              color="primary" [pTooltip]="'Save' | translate" tooltipPosition="top" style="background-color: #190FD1;">
              <i class="fa fa-floppy-o" style="color: #fff;"></i>
            </button>
            <button type="button" mat-raised-button class="list-btn" [pTooltip]="'HistoryBatchList' | translate"
              type="button" tooltipPosition="top" style="margin-left: 10px;" (click)="openHistorybatchModal($event)">
              <i class="fa fa-list" style="color: #fff"></i>
            </button>
            <button type="button" mat-raised-button class="refresh-btn" [pTooltip]="'Reset' | translate"
              tooltipPosition="top" style="margin-left: 10px;" (click)="RefreshMaterialConsumption()">
              <i class="fa fa-refresh" style="color: #fff"></i>
            </button>

          </div>
        </div>
        <!--second row-->
        <div class="content-row-flex-both-end ">
          <!--table-->
          <table mat-table matTableResponsive [dataSource]="materialConsumptionDataSource"
            class="basic-table basic-table1 checklist_modal1 plant-model-table table_color dowtime-table" matSort>

            <ng-container matColumnDef="Action">
              <th mat-header-cell *matHeaderCellDef>
                <p class="header-text">Actions</p>
              </th>
              <td mat-cell *matCellDef="let element" class="row-action-btns-column">
                <div class="row-action-btns">
                  <button (click)="editMaterialConsumptionHistoryBatch(element)" type="submit" mat-raised-button
                    style="background-color:#190FD1" color="primary" [pTooltip]="'Update' | translate"
                    tooltipPosition="top">
                    <i class="fa fa-pencil" style="color: #fff"></i>
                  </button>
                </div>
              </td>
            </ng-container>
            <!-- Item Type Column -->
            <ng-container matColumnDef="itemtype">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'ItemType' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Name}}</td>
            </ng-container>

            <!-- Batch Column -->
            <ng-container matColumnDef="batch">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'LotCodeOrDetail' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.BatchNo}}</td>
            </ng-container>

            <!-- length Column -->
            <ng-container matColumnDef="length">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'ActualQuantity' | translate}} {{result}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Result}}</td>
            </ng-container>

            <!-- Remarks Column -->
            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'Remarks' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Remarks}}</td>
            </ng-container>

            <!-- Time Column -->
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'Time' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.RollStarttime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <!-- Created On Column -->
            <ng-container matColumnDef="createdon">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CreatedOn' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <!-- Created by Column -->
            <ng-container matColumnDef="createdby">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CreatedBy' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedBy}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="materialColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: materialColumns"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" colspan="8">{{'NoDataFound' | translate}}</td>
            </tr>
          </table>
        </div>
      </div>
    </form>
    <!-- Food sector -->
    <form class="table-wrapper" [formGroup]="materialFoodSectorConsumptionForm" *ngIf="isFoodSector">
      <div class="table-wrapper">
        <div class="content-top-row content">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{ langObj ? langObj?.LotCode : ('LotCode' | translate) }}</mat-label>
            <input formControlName="mlotCode" readonly matInput name="batchdesc" />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{ langObj ? langObj?.EstimatedQuantity : ('EstimatedQuantity' | translate) }}</mat-label>
            <input formControlName="mActQtys" readonly type="number" matInput name="length" />
          </mat-form-field>

          <mat-form-field appearence="fill"
            class="top-row-first-filed-item top-row-first-filed-item-order-processing time-field"
            style="margin-left: 10px;">
            <input matInput [ngxMatDatetimePicker]="mtimePicker" placeholder="Time" formControlName="mTime" />
            <mat-error class="error-msg" *ngIf="checkErrorMaterialFoodConsumption('mTime', 'required')">time is
              required</mat-error>
            <mat-datepicker-toggle matSuffix [for]="$any(mtimePicker)"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #mtimePicker> </ngx-mat-datetime-picker>
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{ langObj ? langObj?.Remarks : ('Remarks' | translate) }}</mat-label>
            <input formControlName="remarks" type="text" matInput />
          </mat-form-field>
        </div>

        <div class="content-row-flex-both-end">
          <!--table-->
          <table mat-table class="basic-table checklist_modal1 plant-model-table" [dataSource]="ItemBOMList" matSort>
            <ng-container matColumnDef="alternateMaterial">
              <th mat-header-cell *matHeaderCellDef>
                <p class="header-text">{{langObj ? langObj?.Action : ('Action' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" class="row-action-btns-column">
                <div class="row-action-btns">
                  <button mat-icon-button class="edit-btn" aria-label="Edit Row" type="button"
                    (click)="openAlternativeItemsModel(element)" matTooltip="View" matTooltipClass="custom-tooltip"
                    matTooltipPosition="above" style="background-color: lightseagreen;">
                    <!-- Replace the "d" attribute with your desired SVG path data -->
                    <mat-icon style="color: #fff;">list_alt</mat-icon>

                  </button>
                </div>
              </td>
            </ng-container>
            <!-- Item Type Column -->
            <ng-container matColumnDef="itemtype">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ItemCode : ('ItemCode' | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.ItemCode}}</td>
            </ng-container>

            <ng-container matColumnDef="itemDesc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ItemDescription : ('ItemDescription' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.ItemDesc}}</td>
            </ng-container>
            <ng-container matColumnDef="itemuom">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Item : ('Item' | translate)}} UOM</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.UOM}}</td>
            </ng-container>

            <!-- Batch Column -->
            <ng-container matColumnDef="estQty">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text"> {{ langObj ? langObj?.RequiredQuantity : ('RequiredQuantity' | translate)}}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.EsimatedQty}}</td>
            </ng-container>

            <!-- length Column -->
            <ng-container matColumnDef="consumedQuantity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.TotalConsumedQuantity : ('TotalConsumedQuantity' |
                  translate)}}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.consumedQuantity}}</td>
            </ng-container>
            <ng-container matColumnDef="actQty">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.ActualQuantity : ('ActualQuantity' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                <input type="number" style="height: 35px;color: #000;"
                  (keyup)="changeActQty($event,element.ItemBOMDetailId)" class="w120"
                  value="{{element.ItemBOMValue}}" />
              </td>
            </ng-container>
            <ng-container matColumnDef="actQtyDrums">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.ActualQuantityDrums : ('ActualQuantityDrums' |
                  translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">
                <input type="number" style="height: 35px;color: #000;"
                  (keyup)="changeActQtyDrums($event,element.ItemBOMDetailId)" class="w120"
                  value="{{element.ItemBOMValueDrums}}" />
              </td>
            </ng-container>
            <ng-container matColumnDef="traceCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.traceCode : ('traceCode' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" class="trace-code-cell" style="display: flex;
              max-width: 158px;
              justify-content: space-between;">
                <div class="input-container">
                  <input (keyup)="changeTraceCode($event, element.ItemBOMDetailId)"
                    style="width: 80px;height: 35px; color: #000;" [value]="element.traceCode" />
                </div>
                <div class="icon-container">
                  <mat-icon style="color: #fff;"
                    (click)="scanQrCode(element.ItemBOMDetailId)">qr_code_scanner</mat-icon>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="kgUnit">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.KGUnit : ('KGUnit' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.MinSkuUnit}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="materialSubColumns1"></tr>
            <tr mat-row *matRowDef="let row; columns: materialSubColumns1">
            </tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" colspan="8">{{ langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
            </tr>
          </table>
        </div>



        <div class="content-top-row content-top-row-order-processing content"
          style="display: flex; justify-content: flex-end; height: 40px;">


          <button (click)="SaveFoodSectorMaterialConsumption()" type="submit" mat-raised-button color="primary"
            [pTooltip]="'Save' | translate" tooltipPosition="top">
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>


          <button type="button" mat-raised-button class="list-btn" [pTooltip]="'HistoryMaterialBatchList' | translate"
            tooltipPosition="top" style="margin-left: 10px; margin-right: 10px;"
            (click)="openHistoryFoodMaterialModal()">
            <i class="fa fa-list" style="color: #fff"></i>
          </button>
          <button mat-raised-button class="refresh-btn" [pTooltip]="'Reset' | translate" tooltipPosition="top"
            style="margin-left: 10px;" (click)="RefreshMaterialSubConsumption()">
            <i class="fa fa-refresh" style="color: #fff"></i>
          </button>

        </div>
        <div class="content-row-flex-both-end">
          <!--table-->
          <table mat-table [dataSource]="batchItemBOMList" class="basic-table checklist_modal1 plant-model-table"
            matSort>
            <ng-container matColumnDef="isrework">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.IsRework : ('IsRework' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.IsRework === true ? 'Yes':'No'}}</td>
            </ng-container>
            <!-- Batch Column -->
            <ng-container matColumnDef="batch">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.LotCodeOrDetail : ('LotCodeOrDetail' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.BatchNo}}</td>
            </ng-container>

            <!-- length Column -->
            <ng-container matColumnDef="length">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">Required Quantity
                  {{result}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Estimated}}</td>
            </ng-container>

            <ng-container matColumnDef="totalActQty">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.TotalActualQuantity : ('TotalActualQuantity' |
                  translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Actual}}</td>
            </ng-container>

            <ng-container matColumnDef="totalActQtyDrum" *ngIf="isFoodSector">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.TotalActualQuantityDrum : ('TotalActualQuantityDrum' |
                  translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.ActualValueDrum}}</td>
            </ng-container>

            <!-- Remarks Column -->
            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Remarks}}</td>
            </ng-container>

            <!-- Time Column -->
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Time : ('Time' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.RollStarttime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <!-- Created On Column -->
            <ng-container matColumnDef="createdon">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.CreatedOn : ('CreatedOn' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>


            <!-- Created by Column -->
            <ng-container matColumnDef="createdby">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.CreatedBy : ('CreatedBy' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedBy}}</td>
            </ng-container>

            <ng-container matColumnDef="sfdcactions">
              <th mat-header-cell *matHeaderCellDef>
                <p class="header-text">{{langObj ? langObj?.Action : ('Action' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" class="row-action-btns-column">
                <div class="row-action-btns">
                  <button mat-icon-button class="edit-btn" aria-label="Edit Row" type="button"
                    (click)="openPopupViewForMaterialHistory(element)" matTooltip="View"
                    matTooltipClass="custom-tooltip" matTooltipPosition="above"
                    style="background-color: lightseagreen;">
                    <svg width="12" height="12" class="svg-icon" viewBox="0 0 20 20">
                      <path fill="white"
                        d="M19.471,8.934L18.883,8.34c-2.096-2.14-4.707-4.804-8.903-4.804c-4.171,0-6.959,2.83-8.996,4.897L0.488,8.934c-0.307,0.307-0.307,0.803,0,1.109l0.401,0.403c2.052,2.072,4.862,4.909,9.091,4.909c4.25,0,6.88-2.666,8.988-4.807l0.503-0.506C19.778,9.737,19.778,9.241,19.471,8.934z M9.98,13.787c-3.493,0-5.804-2.254-7.833-4.3C4.182,7.424,6.493,5.105,9.98,5.105c3.536,0,5.792,2.301,7.784,4.332l0.049,0.051C15.818,11.511,13.551,13.787,9.98,13.787z">
                      </path>
                      <circle fill="white" cx="9.98" cy="9.446" r="1.629"></circle>
                    </svg>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="materialFoodSectorColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: materialFoodSectorColumns"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" colspan="8">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
            </tr>
          </table>
        </div>
      </div>
    </form>
  </div>
  <!-- production Output -->
  <div id="wrapper3">
    <form [formGroup]="productionOutputForm" class="table-wrapper">
      <div class="wrapper-box background wrapper-box background-shadow ">
        <div class="title">
          <h1> {{'ProductionOutput' | translate}}<span>{{selectedunit}}</span></h1>
          <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
            (click)="onPrevious8()">Previous</button>
        </div>
      </div>
      <div class="content-top-row content">
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px">
          <mat-label>{{langObj ? langObj?.BatchConsumption : ('BatchConsumption' | translate)}}</mat-label>
          <mat-select formControlName="batchcon" panelClass="testClass" style="margin-left: 1px">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="batchConsumptionList"
              (filteredReturn)="filteredbatchConsumptionList = $event"></mat-select-filter>
            <mat-option *ngFor="let batch of  filteredbatchConsumptionList" [value]="batch.TypeId">
              {{batch.TypeName}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px">
          <mat-label>{{langObj ? langObj?.LoteCodeOrPallet : ('LoteCodeOrPallet' | translate)}}</mat-label>
          <input formControlName="pallet" matInput name="test" [readonly]="isAuto" autocomplete="off" />
        </mat-form-field>
        <div class="inputField date_sfdc">
          <nz-date-picker class="calender-input sfdcCalender-input" id="timePicker" formControlName="time"
            nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
          <span style="color: #fff; opacity: initial;" class="floating-text">{{langObj ? langObj?.Time: ('Time' |
            translate)}}</span>
        </div>

        <mat-form-field *ngIf="machineType" appearence="fill"
          class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="margin-left: 10px">
          <mat-label>{{langObj ? langObj?.StorageTanks : ('StorageTanks' | translate)}}</mat-label>
          <mat-select formControlName="storageTanks" panelClass="testClass" style="margin-left: 1px">
            <mat-select-filter [placeholder]="'Search'" [displayMember]="'StorageTank'" [array]="storageTanksList"
              (filteredReturn)="filteredStorageTanksList = $event"></mat-select-filter>
            <mat-option *ngFor="let tank of filteredStorageTanksList" [value]="tank.TankId">
              {{tank.StorageTank}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px">
          <mat-label>{{langObj ? langObj?.ActualQuantity : ('ActualQuantity' | translate)}} {{Result}}</mat-label>
          <input type="number" formControlName="actQty" matInput name="actqty" autocomplete="off" />
        </mat-form-field>
        <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
          style="margin-left: 10px">
          <mat-label>{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</mat-label>
          <input formControlName="remarks" matInput name="remarks" autocomplete="off" />
        </mat-form-field>
      </div>
      <div class="content-top-row" style="margin-bottom: 15px;">

        <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after" matBadgeColor="accent"
          MatBadgeSize="large" disableRipple style="margin-left: 10px;">
          {{langObj ? langObj?.TargetQuantity : ('TargetQuantity' | translate)}}: {{targetQty}}
        </button>
        <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after" matBadgeColor="accent"
          MatBadgeSize="large" disableRipple style="margin-left: 10px;">
          {{total1}}
        </button>

      </div>

      <!--second row-->
      <div [ngClass]="productionOutputDataSource !== undefined ? 'table-overflow': ''">
        <!--table-->
        <table [dataSource]="productionOutputDataSource" mat-table
          class="checklist_modal1 basic-table plant-model-table theight" matSort>
          <!-- Checklist Column -->
          <ng-container matColumnDef="checklist">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Checklist : ('Checklist' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Name}}</td>
          </ng-container>

          <!-- Values Column -->
          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Values : ('Values' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <input *ngIf="element.DataType === 'bool' && element.BatchCheckListValue === 'true'" [checked]="true"
                type="checkbox" (change)="checkListFunction(element.BatchCheckListTypeId, $event)" color="primary">
              <input *ngIf="element.DataType === 'bool' && element.BatchCheckListValue !== 'true'" type="checkbox"
                (change)="checkListFunction(element.BatchCheckListTypeId, $event)" color="primary">
              <input *ngIf="element.DataType === 'string'" type="text" style="height: 39px;width: 180px;"
                [value]="element.BatchCheckListValue === undefined ? '' : element.BatchCheckListValue"
                (change)="checkListFunction(element.BatchCheckListTypeId, $event)">
              <input *ngIf="element.DataType === 'number'" type="number" style="height: 39px;width: 180px;"
                [value]="element.BatchCheckListValue"
                (change)="checkListFunction(element.BatchCheckListTypeId, $event)">
              <select (change)="checkListFunction(element.BatchCheckListTypeId, $event)" appearance="fill"
                class="field-fill" *ngIf="element.DataType === 'dropdown'" style="width: 180px;">
                <option *ngFor="let list of newDropdownList[i]"
                  [selected]="element.BatchCheckListValue === list.TypeName" [value]="list.TypeName"
                  style="color: #fff;">
                  {{list.TypeName}}
                </option>
              </select>
              <!-- <input *ngIf="element.DataType === 'dropdown'" type="text" [value]="element.BatchCheckListValue"> -->
              <mat-form-field appearance="fill" class="field-fill" *ngIf="element.DataType === 'date'"
                style="width: 180px;">
                <input matInput [matDatepicker]="pickerspoedit" [value]="element.BatchCheckListValue"
                  (dateInput)="checkListFunction(element.BatchCheckListTypeId, $event)">
                <mat-datepicker-toggle matSuffix [for]="pickerspoedit"></mat-datepicker-toggle>
                <mat-datepicker #pickerspoedit></mat-datepicker>
              </mat-form-field>

            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="productionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: productionColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="8">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
          </tr>
        </table>
      </div>
      <div class="content-top-row content-top-row-order-processing content"
        style="display: flex; justify-content: flex-end; height: 40px;">
        <button (click)="UpdateJBBatchInfoForProductionOutput()" type="submit" *ngIf="!productionMode && IsWrite"
          mat-raised-button color="primary" [pTooltip]="'Update' | translate" tooltipPosition="top">
          <i class="fa fa-pencil" style="color: #fff"></i>
        </button>
        <button (click)="SaveJBBatchInfoForProductionOutput()" type="submit" *ngIf="productionMode && IsWrite"
          mat-raised-button color="primary" [pTooltip]="'Save' | translate" tooltipPosition="top">
          <i class="fa fa-floppy-o" style="color: #fff"></i>
        </button>
        <button type="button" mat-raised-button class="list-btn" [pTooltip]="'HistoryBatchList' | translate"
          tooltipPosition="top" style="margin-left: 10px; margin-right: 10px;" (click)="openHistoryModal()">
          <i class="fa fa-list" style="color: #fff"></i>
        </button>
        <button mat-raised-button class="refresh-btn" [pTooltip]="'Reset' | translate" tooltipPosition="top"
          style="margin-left: 10px;" (click)="RefreshProductionOutput()">
          <i class="fa fa-refresh" style="color: #fff"></i>
        </button>
      </div>
      <!--Third row-->
      <div class="content-row-flex-both-end checklist_modal1" style="margin-top: 0;">
        <!--table-->
        <table [dataSource]="HistoryBatchDataSource1" mat-table class="basic-table plant-model-table" matSort>
          <!-- Batch Consumption -->
          <ng-container matColumnDef="batchCon">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.BatchConsumption : ('BatchConsumption' | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element" style="padding: 13px 3px;">{{element?.IPBatchNo}}</td>
          </ng-container>

          <!--Lotcode/Pallet-->
          <ng-container matColumnDef="lotcode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.LoteCodeOrPallet : ('LoteCodeOrPallet' | translate) }}
              </p>
            </th>
            <td mat-cell *matCellDef="let element" style="padding: 13px 3px;">{{element?.BatchNo}}</td>
          </ng-container>
          <!-- Act Qty Column -->
          <ng-container matColumnDef="act">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.ActualQuantity : ('ActualQuantity' | translate) }}
                {{Result}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Result}}</td>
          </ng-container>

          <!-- Remakrs Column -->
          <ng-container matColumnDef="remarks">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.Remarks: ('Remarks' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Remarks}}</td>
          </ng-container>

          <!-- Time Column -->
          <ng-container matColumnDef="time">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.Time : ('Time' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.RollStarttime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
          </ng-container>

          <!-- Created on Column -->
          <ng-container matColumnDef="createdon">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.CreatedOn : ('CreatedOn' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss"}}</td>
          </ng-container>

          <!-- Created by Column -->
          <ng-container matColumnDef="createdby">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.CreatedBy : ('CreatedBy' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.CreatedBy}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.Action : ('Action' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row-action-btns">
                <button mat-icon-button class="edit-btn" aria-label="Edit Row"
                  (click)="editProductionHistoryBatch(element)" *ngIf="IsWrite"
                  [pTooltip]="langObj ? langObj?.Update : ('Update' | translate)" tooltipPosition="top"
                  style="background-color: #3aafe4;">
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.75 9.06298V11.2505H2.9375L9.38917 4.79881L7.20167 2.61131L0.75 9.06298ZM11.0808 3.10715C11.3083 2.87965 11.3083 2.51215 11.0808 2.28465L9.71583 0.919648C9.48833 0.692148 9.12083 0.692148 8.89333 0.919648L7.82583 1.98715L10.0133 4.17465L11.0808 3.10715Z"
                      fill="white" />
                  </svg>
                </button>
                <button type="submit" mat-icon-button class="edit-btn" aria-label="Edit Row"
                  [pTooltip]="langObj ? langObj?.Print : ('Print' | translate)" tooltipPosition="top"
                  style="background-color: crimson;" (click)="GetBarCodeDetails(element)">
                  <svg width="20" height="20" class="svg-icon" viewBox="0 0 20 20">
                    <path fill="white"
                      d="M17.453,12.691V7.723 M17.453,12.691V7.723 M1.719,12.691V7.723 M18.281,12.691V7.723 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M7.309,13.312h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,13.312,7.309,13.312 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M16.625,6.066h-1.449V3.168c0-0.228-0.186-0.414-0.414-0.414H5.238c-0.228,0-0.414,0.187-0.414,0.414v2.898H3.375c-0.913,0-1.656,0.743-1.656,1.656v4.969c0,0.913,0.743,1.656,1.656,1.656h1.449v2.484c0,0.228,0.187,0.414,0.414,0.414h9.523c0.229,0,0.414-0.187,0.414-0.414v-2.484h1.449c0.912,0,1.656-0.743,1.656-1.656V7.723C18.281,6.81,17.537,6.066,16.625,6.066 M5.652,3.582h8.695v2.484H5.652V3.582zM14.348,16.418H5.652v-4.969h8.695V16.418z M17.453,12.691c0,0.458-0.371,0.828-0.828,0.828h-1.449v-2.484c0-0.228-0.186-0.414-0.414-0.414H5.238c-0.228,0-0.414,0.186-0.414,0.414v2.484H3.375c-0.458,0-0.828-0.37-0.828-0.828V7.723c0-0.458,0.371-0.828,0.828-0.828h13.25c0.457,0,0.828,0.371,0.828,0.828V12.691z M7.309,13.312h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,13.312,7.309,13.312M7.309,15.383h5.383c0.229,0,0.414-0.187,0.414-0.414s-0.186-0.414-0.414-0.414H7.309c-0.228,0-0.414,0.187-0.414,0.414S7.081,15.383,7.309,15.383 M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484 M12.691,12.484H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,12.484,12.691,12.484M12.691,14.555H7.309c-0.228,0-0.414,0.187-0.414,0.414s0.187,0.414,0.414,0.414h5.383c0.229,0,0.414-0.187,0.414-0.414S12.92,14.555,12.691,14.555">
                    </path>
                  </svg>

                </button>
                <button mat-icon-button class="edit-btn" aria-label="Edit Row"
                  (click)="openPopupViewForChecklistHistory(element)" matTooltip="View" matTooltipClass="custom-tooltip"
                  matTooltipPosition="above" style="background-color: lightseagreen;">
                  <svg width="12" height="12" class="svg-icon" viewBox="0 0 20 20">
                    <path fill="white"
                      d="M19.471,8.934L18.883,8.34c-2.096-2.14-4.707-4.804-8.903-4.804c-4.171,0-6.959,2.83-8.996,4.897L0.488,8.934c-0.307,0.307-0.307,0.803,0,1.109l0.401,0.403c2.052,2.072,4.862,4.909,9.091,4.909c4.25,0,6.88-2.666,8.988-4.807l0.503-0.506C19.778,9.737,19.778,9.241,19.471,8.934z M9.98,13.787c-3.493,0-5.804-2.254-7.833-4.3C4.182,7.424,6.493,5.105,9.98,5.105c3.536,0,5.792,2.301,7.784,4.332l0.049,0.051C15.818,11.511,13.551,13.787,9.98,13.787z">
                    </path>
                    <circle fill="white" cx="9.98" cy="9.446" r="1.629"></circle>
                  </svg>
                </button>

              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="production1Columns"></tr>
          <tr mat-row *matRowDef="let row; columns: production1Columns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="7">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}d</td>
          </tr>
        </table>
      </div>

      <!-- </div> -->
    </form>

  </div>
  <!-- Process Control -->
  <div id="wrapper4">
    <div class="wrapper-box background wrapper-box background-shadow table-wrapper" style="height: 100%;">
      <div class="title">
        <h1> {{'ProcessControl' | translate}}<span>{{selectedunit}}</span></h1>
        <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
          (click)="onPrevious8()">Previous</button>
      </div>
      <div class="">
        <form [formGroup]="processControlForm">
          <div class="wrapper-box background wrapper-box background-shadow table-wrapper" style="padding-top: 0;">
            <div [ngClass]="{'fullscreen': isCardExpanded}">
              <div class="sfdc_responsive1 content-top-row Quality_sfdc_responsive"
                style="padding: 0; margin-top: 10px !important; margin-bottom: 10px;">
                <mat-form-field appearence="fill"
                  class="width top-row-first-filed-item top-row-first-filed-item-order-processing Quality_sfdc_responsive1 select-item1"
                  style="width: 15%;">
                  <mat-label class="placeholder-title">{{ langObj ? langObj?.GroupType : ('GroupType' | translate) }}
                  </mat-label>
                  <mat-select formControlName="groupType" panelClass="testClass" name="Group" required
                    (selectionChange)="variableEventMode()">
                    <mat-option *ngFor="let c of groupTypeList" [value]="c.parameterGroupTypeId">
                      {{c.groupTypeName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearence="fill"
                  class="width top-row-first-filed-item top-row-first-filed-item-order-processing Quality_sfdc_responsive1 select-item1"
                  style="width: 15%; margin-left: 20px" *ngIf="processGroupType === 'Event'">
                  <mat-label>{{ langObj ? langObj?.EventType : ('EventType' | translate) }}</mat-label>
                  <mat-select formControlName="eventType" panelClass="testClass" (selectionChange)="onToProcessDate()">
                    <mat-option *ngFor="let interval of processIntervalTypeDDL" [value]="interval.val">{{interval.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearence="fill"
                  class="width top-row-first-filed-item top-row-first-filed-item-order-processing Quality_sfdc_responsive1 select-item1"
                  *ngIf="processGroupType === 'Time'" style="width: 15%; margin-left: 20px">
                  <mat-label class="placeholder-title">{{ langObj ? langObj?.SelectInterval : ('SelectInterval' |
                    translate)
                    }}</mat-label>
                  <mat-select formControlName="timeInterval" panelClass="testClass" name="Group"
                    (selectionChange)="onIntervalChange()" required>
                    <mat-option *ngFor="let c of intervalList" [value]="c.Interval">
                      {{c.Interval }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <div *ngIf="processGroupType === 'Manual'"
                  class="width top-row-first-filed-item-order-processing Quality_sfdc_responsive1 ng-tns-c393-0 ng-star-inserted  test-primeng"
                  style="width: 20%;margin-left: 20px;">
                  <label class="floating-label-multiselect">Parameter Group</label>
                  <p-multiSelect class="form-select" (onChange)="onProcessParameterGroupChange()" inputId="multiselect"
                    formControlName="parameterGroup" [options]="processparameterGroupList" optionLabel="vgDesc"
                    [filter]="true">
                  </p-multiSelect>
                </div>

                <div style="width: auto !important;"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                  style="width: 20%;background: transparent !important;border-radius: 0px !important;">
                  <label class="floating-label">Date Range</label>
                  <input type="text" matInput ngxDaterangepickerMd formControlName="datePicker"
                    style="background-color: #000!important ;color: white;margin-left:5px;width:85%!important"
                    (change)="onToProcessDate()" [timePicker]="true" [timePicker24Hour]="true" [showDropdowns]="true"
                    [closeOnAutoApply]="true" [locale]="{format: 'DD/MM/YYYY HH:mm'}" [autoApply]="true" />
                </div>
                <mat-form-field appearence="fill"
                  class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="display :none;">
                  <mat-label>Process Type</mat-label>
                  <mat-select panelClass="testClass" [disabled]="true" placeholder="Process Type"
                    formControlName="processType" name="group">
                    <mat-option value="PO">Process Order</mat-option>
                    <mat-option value="Batch">Batch</mat-option>
                    <mat-option value="Lotcode">Lotcode/Pallet</mat-option>
                  </mat-select>
                </mat-form-field>

                <button mat-mini-fab color="accent" (click)="manualInput('process')"
                  *ngIf="processGroupType === 'Manual'"
                  [pTooltip]="langObj ? langObj?.ManualInput : ('ManualInput' | translate)" style="margin-left: 16px;">
                  <!-- {{'ManualInput' | translate}} -->
                  <mat-icon>plus_one</mat-icon>
                </button>
                <button mat-mini-fab mat-button (click)="csvExportPC()" pTooltip="CSV Export" tooltipPosition="top"
                  style="margin-left: 20px;margin-top: 5px;"><img src="assets/images/csv-file-format.png">
                </button>
                <button mat-mini-fab mat-button (click)="excelExportPC()" pTooltip="Excel Export" tooltipPosition="top"
                  style="margin-top: 5px;">
                  <i class="fa fa-file-excel-o" style="color: #fff;" aria-hidden="true"></i>
                </button>
                <button mat-mini-fab mat-button (click)="pdfExport()" pTooltip="PDF Export" tooltipPosition="top"
                  style="margin-top: 5px;">
                  <i class="fa fa-file-pdf-o" style="color: #fff;" aria-hidden="true"></i>
                </button>
                <button mat-mini-fab mat-button mat-dialog-close color="accent" pTooltip="Expand Grid"
                  tooltipPosition="top" *ngIf="Exdpandhide" (click)="expandprocess()"
                  style="margin-bottom: 10px; margin-left: 10px;">
                  <mat-icon>fullscreen</mat-icon>
                </button>
                <button mat-mini-fab mat-button mat-dialog-close color="accent" (click)="closeprocess()"
                  style="margin-bottom: 10px; margin-left: 10px;" *ngIf="Collapsehide">
                  <mat-icon>fullscreen_exit</mat-icon>
                </button>
              </div>
              <div class='sfdc_responsive1 content-top-row Quality_sfdc_responsive'>


                <div class="d-flex justify-content-between" style="align-items: center; padding: 10px;">
                  <mat-spinner-button [options]="spinnerButtonOptions"
                    (btnClick)="onClickParamterAnalysisProcessControl()" class="loader" id="selectedRows"
                    style="margin: 10px 10px;">
                  </mat-spinner-button>
                  <mat-spinner-button [options]="spinnerButtonOptions1"
                    (btnClick)="onClickParamterComparsionProcessControl()" class="loader" id="selectedRows"
                    style="margin: 10px 10px;">
                  </mat-spinner-button>
                  <mat-spinner-button [options]="spinnerButtonOptionsOrders"
                    (btnClick)="onClickControlProcessOrderProcessControl()" class="loader" id="selectedRows"
                    style="margin: 10px 10px;">
                  </mat-spinner-button>
                </div>
                <button type="button" (click)="onProcessControlRefresh()" mat-mini-fab mat-button color="primary"
                  pTooltip="Refresh" tooltipPosition="top">
                  <i class="fa fa-refresh" style="color: #fff"></i>
                </button>
                <button type="button" (click)="ProcessControltoggleTimer()" mat-mini-fab mat-button color="primary"
                  [pTooltip]="processControlResumeInterval ? 'Stop Auto Refresh': 'Resume Auto Refresh' "
                  tooltipPosition="top" style="margin-left: 10px;">
                  <mat-icon *ngIf="processControlResumeInterval">pause_circle_outline</mat-icon>
                  <mat-icon *ngIf="!processControlResumeInterval">play_arrow</mat-icon>
                </button>

              </div>
              <ag-grid-angular style="width: 100%; height: 30vw;overflow-y: scroll;" class="ag-theme-alpine"
                id="gridContainerProcessControl" [rowData]="rowDataProcessControl"
                [columnDefs]="columnDefsProcessControl" [autoGroupColumnDef]="autoGroupColumnDef"
                [gridOptions]="gridOptionsProcessControl" [rowSelection]="rowSelection" [rowMultiSelectWithClick]="true"
                (gridReady)="onProcessGridReady($event)" (cellValueChanged)="onCellValueChanged($event)"
                [frameworkComponents]="frameworkComponents" [loadingOverlayComponent]="loadingOverlayComponent"
                [loadingOverlayComponentParams]="loadingOverlayComponentParams" [pagination]="true"
                [getContextMenuItems]="getContextMenuItemsProcessControl" [groupHideOpenParents]="true"
                [enterMovesDown]="true" [enterMovesDownAfterEdit]="true">
              </ag-grid-angular>
            </div>
          </div>
          <ng-template #pdfModel>

            <div mat-dialog-title>
              <div class="d-flex justify-content-between align-items-center">
                <h3>Select Columns For PDF File</h3>
                <button mat-mini-fab mat-button mat-dialog-close color="warn" pTooltip="Close" tooltipPosition="top">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
            <hr>
            <mat-dialog-content>
              <div style="width: 100%; height: 290px; margin-top: 10px 0px 10px;">
                <div class="p-grid p-fluid" style="margin: 10px 0px 10px;">
                  <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                    <h4 style="text-decoration: underline;">Select Columns:</h4>
                    <label>{{langObj ? langObj?.SelectColumns : ('SelectColumns' | translate)}}</label>
                    <p-multiSelect class="internal-p-select" [options]="columns" [filter]="true"
                      (onChange)="columnSelect()" defaultLabel="Select Column" formControlName="pdfcolumn"
                      optionLabel="headerName"></p-multiSelect>
                  </div>
                  <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                    <h3 style="text-decoration: underline;">Selected Columns:</h3>
                    <p>{{selectedColumns}} </p>
                  </div>
                </div>
              </div>
              <hr>
              <div mat-dialog-title>
                <div class="d-flex justify-content-between align-items-center">
                  <button type="button" mat-raised-button color="warn"
                    style="background-color: #0f0fd1;font-size: 14px!important; margin-left: 20px;height:40px;margin-top: 5px;"
                    (click)="downloadPDF()">
                    <span style="font-size: 12px;color: white;">Download PDF</span></button>
                </div>
              </div>
            </mat-dialog-content>
          </ng-template>
        </form>

      </div>


      <p-dialog [contentStyle]="{ overflow: 'scroll' }" header="{{paramterSpcecificationName }} - Specifications"
        [(visible)]="processControlSpecificationModal" [style]="{ width: '50vw' }" [maximizable]="true"
        [baseZIndex]="10000" [resizable]="true">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table mat-table class="basic-table basic-table1 plant-model-table dowtime-table " matSort
              [dataSource]="parameterspecifications">

              <ng-container matColumnDef="LRL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">LRL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.LSL}}</td>
              </ng-container>

              <ng-container matColumnDef="LSL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">LSL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.LCL}}</td>
              </ng-container>

              <ng-container matColumnDef="LWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">LWL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.LWL}}</td>
              </ng-container>

              <ng-container matColumnDef="TGT">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">TGT</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.TGT}}</td>
              </ng-container>

              <ng-container matColumnDef="UWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">UWL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.UWL}}</td>
              </ng-container>

              <ng-container matColumnDef="USL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">USL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.UCL}}</td>
              </ng-container>

              <ng-container matColumnDef="URL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">URL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.USL}}</td>
              </ng-container> -->
              <tr mat-header-row *matHeaderRowDef="processcontrolcolumns"></tr>
              <tr mat-row *matRowDef="let row; columns: processcontrolcolumns"></tr>
            </table>
            <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]" showFirstLastButtons
              style="color:#0f0fd1 !important;border-radius:4px!important;">
            </mat-paginator>
          </div>
        </div>

      </p-dialog>

      <!-- displayProcssDefectModal -->

      <p-dialog [contentStyle]="{ overflow: 'scroll' }" header="{{paramterSpcecificationName }} - Specifications"
        [(visible)]="displayProcssDefectModal" [style]="{ width: 'auto' }" [maximizable]="true" [baseZIndex]="10000"
        [resizable]="true">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table mat-table class="basic-table basic-table1 plant-model-table dowtime-table" matSort
              [dataSource]="parametrdefect">
              <ng-container matColumnDef="DefectMode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Failure Mode Details</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.defectmode}}</td>
              </ng-container>

              <ng-container matColumnDef="Department">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Department</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.department}}</td>
              </ng-container>

              <ng-container matColumnDef="Assembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Assembly</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.assembly}}</td>
              </ng-container>

              <ng-container matColumnDef="Component">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Component</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.component}}</td>
              </ng-container>

              <ng-container matColumnDef="Subassembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Subassembly</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.subassembly}}</td>
              </ng-container>

              <ng-container matColumnDef="Unit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Unit</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.Unit}}</td>
              </ng-container>

              <ng-container matColumnDef="Line">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Line</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.Line}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="defectColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: defectColumns"></tr>
            </table>
            <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]"
              style="color:#0f0fd1 !important;border-radius:4px!important;" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </p-dialog>
    </div>
  </div>
  <!--END  Process Control -->

  <!-- waste Form Started  -->
  <div id="wrapper5">
    <form [formGroup]="wasteForm">
      <div class="wrapper-box background wrapper-box background-shadow table-wrapper">
        <div class="title">
          <h1> {{'Waste' | translate}}<span>{{selectedunit}}</span></h1>
          <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
            (click)="onPrevious8()">Previous</button>
        </div>
        <div class="content-top-row content">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 1px">
            <mat-label>{{'CategoryType' | translate}}</mat-label>
            <mat-select formControlName="categoryType" panelClass="testClass" name="cattype">
              <mat-option *ngFor="let fault of FaultList" [value]="fault.FaultId"> {{fault.FaultName}} </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="inputField date_sfdc">
            <nz-date-picker class="calender-input sfdcCalender-input" id="time2Picker" formControlName="dateTime"
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true">
            </nz-date-picker>
            <span class="floating-text">{{'Time' | translate}}</span>
          </div>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{resultWaste}}</mat-label>
            <input type="number" formControlName="uom" matInput name="uom" required />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{name}}</mat-label>
            <input formControlName="failureMode" matInput name="failuremode" />
          </mat-form-field>
        </div>
        <div class="content-top-row content" style="margin-top: 20px; display: flex; justify-content: space-between;">
          <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after" matBadgeColor="accent"
            MatBadgeSize="large" disableRipple style="margin-left: 10px;" *ngIf="wasteButtonShow">
            {{totalWaste}}
          </button>
          <div>
            <button (click)="UpdateJBWasteInfo()" type="submit" *ngIf="!wasteMode && IsWrite" mat-raised-button
              color="primary" [pTooltip]="'Update' | translate" tooltipPosition="top" [disabled]="!wasteForm.valid">
              <i class="fa fa-pencil" style="color: #fff"></i>
            </button>
            <button (click)="SaveJBWasteInfo()" type="submit" *ngIf="wasteMode && IsWrite" mat-raised-button
              color="primary" [pTooltip]="'Save' | translate" tooltipPosition="top" [disabled]="!wasteForm.valid"
              style="background-color: #190FD1;">
              <i class="fa fa-floppy-o" style="color: #fff"></i>
            </button>
            <button type="button" mat-raised-button class="list-btn" [pTooltip]="'WasteHistoryList' | translate"
              tooltipPosition="top" style="margin-left: 10px;" (click)="openWasteHistoryModal()">
              <i class="fa fa-list" style="color: #fff"></i>
            </button>
            <button mat-raised-button class="refresh-btn" [pTooltip]="'Reset' | translate" tooltipPosition="top"
              style="margin-left: 10px;" (click)="RefreshWaste()">
              <i class="fa fa-refresh" style="color: #fff"></i>
            </button>
          </div>
        </div>
        <!--second row-->
        <div class="content-row-flex-both-end">
          <!--table-->
          <table [dataSource]="wasteDataSource1" mat-table
            class="basic-table basic-table1 plant-model-table dowtime-table" matSort>
            <!-- Category Type Column -->
            <ng-container matColumnDef="cattype">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CategoryType' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.FaultName}}</td>
            </ng-container>

            <!-- Time Column -->
            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'Time' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Time | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <!-- Failure Mode Column -->
            <ng-container matColumnDef="failure">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{name}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Remarks}}</td>
            </ng-container>

            <!-- UoM Column -->
            <ng-container matColumnDef="uom">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{resultWaste}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Amount}}</td>
            </ng-container>

            <!-- Created On Column -->
            <ng-container matColumnDef="createdon">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CreatedOn' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedOn | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <!-- Created by Column -->
            <ng-container matColumnDef="createdby">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CreatedBy' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedBy}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="wasteColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: wasteColumns"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" colspan="6">{{'NoDataFound' | translate}}</td>
            </tr>
          </table>
        </div>
      </div>
    </form>
  </div>
  <!--END waste Form Started  -->

  <!-- down Time Started  -->

  <div id="wrapper6">

    <div class="wrapper-box background wrapper-box background-shadow table-wrapper">
      <div class="title" style="display: flex;">
        <h1>
          {{'DownTime' | translate}}<span>{{selectedunit}}</span>
        </h1>
        <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
          (click)="onPrevious8()">Previous</button>
      </div>
      <div class="d-flex align-items-center" style="margin-top: 9px;">
        <button id="downTimer" type="button" (click)="downTimeStarted ? stopDownTime() : startDownTime()"
          mat-raised-button color="accent">
          {{downTimeStarted ? 'Stop Downtime' :'Start Downtime'}}
        </button>
        <div class="d-flex align-items-center">
          <h3 id="timer_blinks" class="timer_number stop_timer_number" style="color: white;">{{timer}}</h3>
        </div>
      </div>
      <form [formGroup]="downTimeForm">
        <div class="content-top-row content">
          <input formControlName="Id" [hidden]="true">
          <div class="inputField date_sfdc">
            <nz-date-picker class="calender-input sfdcCalender-input" (ngModelChange)="getMinutes($event)"
              id="startPicker" formControlName="startDate" #ref nzFormat="dd/MM/yyyy HH:mm"
              [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
            <span style="color:#fff" class="floating-text">{{ langObj ? langObj?.StartTime : ('Start Time' | translate)
              }}</span>
            <p class="invalid-feedback" *ngIf="
            downTimeForm.get('startDate')?.touched &&
            downTimeForm.get('startDate')?.hasError('required')
          ">
              * Start Date is required
            </p>
          </div>
          <div class="inputField">
            <nz-date-picker class="calender-clear sfdcCalender-clear" (ngModelChange)="getMinutes($event)"
              id="endPicker" formControlName="endDate" #ref nzFormat="dd/MM/yyyy HH:mm"
              [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"></nz-date-picker>
            <span style="color:#fff" class="floating-text">{{ langObj ? langObj?.EndTime : ('End Time' | translate)
              }}</span>
          </div>
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{ langObj ? langObj?.Duration : ('Duration' | translate) }}(mins)</mat-label>
            <input formControlName="duration" matInput name="duration" [readonly]="true" />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{ langObj ? langObj?.Faults : ('Faults' | translate) }}</mat-label>
            <mat-select formControlName="fault" panelClass="testClass" name="faults">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'FaultName'" [array]="DTFaultList"
                (filteredReturn)="filteredDTFaultList = $event"></mat-select-filter>
              <mat-option *ngFor="let fault of filteredDTFaultList" [value]="fault.FaultId"> {{fault.FaultName}}
              </mat-option>
            </mat-select>
            <p class="invalid-feedback" *ngIf="
            downTimeForm.get('fault')?.touched &&
            downTimeForm.get('fault')?.hasError('required')
          ">
              * Fault is required
            </p>
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</mat-label>
            <input formControlName="remarks" matInput name="remarks" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="content-top-row" style="margin-top: 20px; display: flex; justify-content: flex-end;">
          <div>
            <button (click)="UpdateJBDowntimeInfo(2)" [disabled]="!downTimeForm.valid" type="submit"
              *ngIf="!downTimeMode && IsWrite" mat-raised-button color="primary"
              [pTooltip]="langObj ? langObj?.Update : ('Update' | translate)" tooltipPosition="top">
              <i class="fa fa-pencil" style="color: #fff"></i>
            </button>
            <button (click)="SaveJBDowntimeInfo()" [disabled]="!downTimeForm.valid" type="submit"
              *ngIf="downTimeMode && IsWrite" mat-raised-button color="primary"
              [pTooltip]="langObj ? langObj?.Save: ('Save' | translate)" tooltipPosition="top">
              <i class="fa fa-floppy-o" style="color: #fff"></i>
            </button>
            <button mat-raised-button class="list-btn"
              [pTooltip]="langObj ? langObj?.DownTimeHistory : ('DownTimeHistory' | translate)" tooltipPosition="top"
              style="margin-left: 10px;" (click)="openModal()">
              <i class="fa fa-list" style="color: #fff"></i>
            </button>
            <button mat-raised-button class="refresh-btn" [pTooltip]="langObj ? langObj?.Reset: ('Reset' | translate)"
              tooltipPosition="top" style="margin-left: 10px;" (click)="RefreshDownTime()">
              <i class="fa fa-refresh" style="color: #fff"></i>
            </button>

          </div>

        </div>
        <!--second row-->
      </form>
      <!--second row-->
      <div class="content-row-flex-both-end">

        <table mat-table [dataSource]="downtimeDataSource"
          class="basic-table basic-table1 plant-model-table dowtime-table" matSort>

          <ng-container matColumnDef="starttime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'StartDate' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.StartTime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
          </ng-container>

          <ng-container matColumnDef="endtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'EndDate' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.EndTime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
          </ng-container>

          <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'Duration' | translate}} (mins)</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Duration}}</td>
          </ng-container>


          <ng-container matColumnDef="fault">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'Faults' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.FaultName}}</td>
          </ng-container>


          <ng-container matColumnDef="remarks">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'Remarks' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Remarks}}</td>
          </ng-container>


          <ng-container matColumnDef="createdon">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'CreatedOn' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.CreatedOn | date: "dd/MM/yyyy hh:mm:ss"}}</td>
          </ng-container>


          <ng-container matColumnDef="createdby">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'CreatedBy' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.CreatedBy}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="downtimeColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: downtimeColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="7">{{'NoDataFound' | translate}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <!-- END down Time -->

  <!-- Quality Control Started -->

  <div id="wrapper7">
    <div class="wrapper-box background wrapper-box background-shadow table-wrapper">
      <div class="title">
        <h1>
          {{'QualityControl' | translate}}<span>{{selectedunit}}</span>
        </h1>
        <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
          (click)="onPrevious8()">Previous</button>
      </div>
      <form [formGroup]="qualityControlForm">
        <div class="wrapper-box background wrapper-box background-shadow table-wrapper"
          style="padding: 0; margin-top: 10px; margin-bottom: 10px;">
          <div [ngClass]="{'fullscreen': isCardExpandedQuality}">
            <div class="sfdc_responsive1 content-top-row Quality_sfdc_responsive"
              style="margin-top: 10px; margin-bottom: 10px;">
              <mat-form-field appearence="fill"
                class="width top-row-first-filed-item top-row-first-filed-item-order-processing Quality_sfdc_responsive1 select-item1"
                style="width: 15%;">
                <mat-label class="placeholder-title">{{ langObj ? langObj?.GroupType : ('GroupType' | translate) }}
                </mat-label>
                <mat-select formControlName="groupType" panelClass="testClass" name="Group" required
                  (selectionChange)="qualityControlEventMode()">
                  <mat-option *ngFor="let c of qualityControlGroupTypeList" [value]="c.parameterGroupTypeId">
                    {{c.groupTypeName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearence="fill"
                class="width top-row-first-filed-item top-row-first-filed-item-order-processing Quality_sfdc_responsive1  select-item1"
                style="width: 15%;margin-left: 20px" *ngIf="qualityGroupType === 'Event'">
                <mat-label>{{ langObj ? langObj?.EventType : ('EventType' | translate) }}</mat-label>
                <mat-select formControlName="eventType" panelClass="testClass"
                  (selectionChange)="onToProcessDateQuanlityControl()">
                  <mat-option *ngFor="let interval of QualityIntervalTypeDDL" [value]="interval.val">{{interval.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearence="fill"
                class=" width top-row-first-filed-item top-row-first-filed-item-order-processing Quality_sfdc_responsive1  select-item1"
                style="width: 15%; margin-left: 20px" *ngIf="qualityGroupType === 'Time'">
                <mat-label class="placeholder-title">{{ langObj ? langObj?.SelectInterval : ('SelectInterval' |
                  translate)
                  }}</mat-label>
                <mat-select formControlName="timeInterval" panelClass="testClass" name="Group"
                  (selectionChange)="onQualityIntervalChange()" required>
                  <mat-option *ngFor="let c of qualityIntervalList" [value]="c.Interval">
                    {{c.Interval }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div *ngIf="qualityGroupType === 'Manual'"
                class="width  top-row-first-filed-item-order-processing Quality_sfdc_responsive1 ng-tns-c393-0 ng-star-inserted test-primeng"
                style="width: 20%;margin-left: 20px;margin-right: 0px;">
                <label class="floating-label-multiselect">Parameter Group</label>
                <p-multiSelect (onChange)="onQualityParameterGroupChange()" inputId="multiselect"
                  formControlName="parameterGroup" [options]="qualityparameterGroupList" optionLabel="vgDesc"
                  [filter]="true">
                </p-multiSelect>
              </div>
              <div style="width: auto !important;"
                class="top-row-first-filed-item top-row-first-filed-item-order-processing"
                style="width: 20%;background: transparent !important;border-radius: 0px !important;margin-left: 10px !important">
                <label class="floating-label">Date Range</label>
                <input type="text" matInput ngxDaterangepickerMd formControlName="datePicker"
                  style="background-color: #000!important ;color: white;margin-left:5px;width:85%!important"
                  (change)="onToProcessDateQuanlityControl()" [timePicker]="true" [timePicker24Hour]="true"
                  [showDropdowns]="true" [closeOnAutoApply]="true" [locale]="{format: 'DD/MM/YYYY HH:mm'}"
                  [autoApply]="true" />
              </div>

              <button mat-mini-fab color="accent" (click)="manualInput('quality')" *ngIf="qualityGroupType === 'Manual'"
                [pTooltip]="langObj ? langObj?.ManualInput : ('ManualInput' | translate)" style="margin-left: 16px;">
                <!-- {{'ManualInput' | translate}} -->
                <mat-icon>plus_one</mat-icon>
              </button>
              <button mat-mini-fab mat-button (click)="csvExportQC()" pTooltip="CSV Export" tooltipPosition="top"
                style="margin-left: 20px;margin-top: 5px;"><img src="assets/images/csv-file-format.png">
              </button>
              <button mat-mini-fab mat-button (click)="excelExportQC()" pTooltip="Excel Export" tooltipPosition="top"
                style="margin-top: 5px;">
                <i class="fa fa-file-excel-o" style="color: #fff;" aria-hidden="true"></i>
              </button>
              <button mat-mini-fab mat-button (click)="pdfExportQC()" pTooltip="PDF Export" tooltipPosition="top"
                style="margin-top: 5px;">
                <i class="fa fa-file-pdf-o" style="color: #fff;" aria-hidden="true"></i>
              </button>
              <button mat-mini-fab mat-button mat-dialog-close color="accent" pTooltip="Expand Grid"
                tooltipPosition="top" *ngIf="ExdpandhideQuality" (click)="expandquality()"
                style="margin-bottom: 10px; margin-left: 10px;">
                <mat-icon>fullscreen</mat-icon>
              </button>
              <button mat-mini-fab mat-button mat-dialog-close color="accent" (click)="closequality()"
                style="margin-bottom: 10px; margin-left: 10px;" *ngIf="CollapsehideQuality">
                <mat-icon>fullscreen_exit</mat-icon>
              </button>
            </div>
            <div class="sfdc_responsive1 content-top-row Quality_sfdc_responsive">


              <div class="d-flex justify-content-between" style="align-items: center;">
                <mat-spinner-button [options]="spinnerButtonOptions"
                  (btnClick)="onClickParamterAnalysisQualityControl()" class="loader" id="selectedRows"
                  style="margin: 10px 10px;">
                </mat-spinner-button>
                <mat-spinner-button [options]="spinnerButtonOptions1"
                  (btnClick)="onClickParamterComparsionQualityControl()" class="loader" id="selectedRows"
                  style="margin: 10px 10px;">
                </mat-spinner-button>
                <mat-spinner-button [options]="spinnerButtonOptionsOrders"
                  (btnClick)="onClickControlProcessOrderQualityControl()" class="loader" id="selectedRows"
                  style="margin: 10px 10px;">
                </mat-spinner-button>
              </div>
              <button type="button" (click)="onQualityControlRefresh()" mat-mini-fab mat-button color="primary"
                pTooltip="Refresh" tooltipPosition="top" style="margin-left: 20px;">
                <i class="fa fa-refresh" style="color: #fff"></i>
              </button>
              <button type="button" (click)="QualityControltoggleTimer()" mat-mini-fab mat-button color="primary"
                [pTooltip]="qualityControlResumeInterval ? 'Stop Auto Refresh': 'Resume Auto Refresh' "
                tooltipPosition="top" style="margin-left: 10px;">
                <mat-icon *ngIf="qualityControlResumeInterval">pause_circle_outline</mat-icon>
                <mat-icon *ngIf="!qualityControlResumeInterval">play_arrow</mat-icon>
              </button>

            </div>
            <ag-grid-angular style="width: 100%; height: 30vw;overflow-y: scroll" class="ag-theme-alpine"
              [rowData]="rowDataQualityControl" [columnDefs]="columnDefsQualityControl" id="gridContainerQualityControl"
              [getContextMenuItems]="getContextMenuItems" [gridOptions]="gridOptionsQualityControl"
              [autoGroupColumnDef]="autoGroupColumnDef" [frameworkComponents]="frameworkComponents"
              [loadingOverlayComponent]="loadingOverlayComponent"
              [loadingOverlayComponentParams]="loadingOverlayComponentParams" [rowSelection]="rowSelection"
              [rowMultiSelectWithClick]="true" (gridReady)="onQualityControlGridReady($event)" [pagination]="true"
              (cellValueChanged)="onQualityControlCellValueChanged($event)" [groupHideOpenParents]="true"
              [enterMovesDown]="true" [enterMovesDownAfterEdit]="true">
            </ag-grid-angular>
          </div>

        </div>
        <ng-template #pdfModelQC>
          <!-- <button (click)="getSelectedRowData()">Click</button> -->
          <div mat-dialog-title>
            <div class="d-flex justify-content-between align-items-center">
              <h3>Select Columns For PDF File</h3>
              <button mat-mini-fab mat-button mat-dialog-close color="warn" pTooltip="Close" tooltipPosition="top">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
          <hr>
          <mat-dialog-content>
            <div style="width: 100%; height: 290px; margin-top: 10px 0px 10px;">
              <div class="p-grid p-fluid" style="margin: 10px 0px 10px;">
                <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                  <h4 style="text-decoration: underline;">Select Columns:</h4>
                  <label>{{langObj ? langObj?.SelectColumns : ('SelectColumns' | translate)}}</label>
                  <p-multiSelect class="internal-p-select" [options]="columnsQC" [filter]="true"
                    (onChange)="columnSelectQC()" defaultLabel="Select Column" formControlName="pdfcolumnQC"
                    optionLabel="headerName"></p-multiSelect>
                </div>
                <div class="p-col-12 p-md-6 p-lg-6 p-xl-6">
                  <h3 style="text-decoration: underline;">Selected Columns:</h3>
                  <p>{{selectedColumnsQC}} </p>
                </div>
              </div>
            </div>
            <hr>
            <div mat-dialog-title>
              <div class="d-flex justify-content-between align-items-center">
                <button type="button" mat-raised-button color="warn"
                  style="background-color: #0f0fd1;font-size: 14px!important; margin-left: 20px;height:40px;margin-top: 5px;"
                  (click)="downloadPDFQC()">
                  <span style="font-size: 12px;color: white;">Download PDF</span></button>
              </div>
            </div>
          </mat-dialog-content>
        </ng-template>
      </form>
      <p-dialog [contentStyle]="{ overflow: 'scroll' }" header="Specifications - {{paramterSpcecificationName}}"
        [(visible)]="displayQualitySpecificationModal" [style]="{ width: '50vw' }" [maximizable]="true"
        [baseZIndex]="10000" [resizable]="true">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table mat-table class="basic-table basic-table1 plant-model-table dowtime-table" matSort
              [dataSource]="parameterspecifications">

              <ng-container matColumnDef="LRL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">LRL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.LRL}}</td>
              </ng-container>

              <ng-container matColumnDef="LSL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">LSL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.LSL}}</td>
              </ng-container>

              <ng-container matColumnDef="LWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">LWL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.LWL}}</td>
              </ng-container>

              <ng-container matColumnDef="TGT">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">TGT</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.TGT}}</td>
              </ng-container>

              <ng-container matColumnDef="UWL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">UWL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.UWL}}</td>
              </ng-container>

              <ng-container matColumnDef="USL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">USL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.USL}}</td>
              </ng-container>

              <ng-container matColumnDef="URL">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">URL</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.URL}}</td>
              </ng-container> -->
              <tr mat-header-row *matHeaderRowDef="processcontrolcolumns"></tr>
              <tr mat-row *matRowDef="let row; columns: processcontrolcolumns"></tr>
            </table>
            <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]"
              style="color:#0f0fd1 !important;border-radius:4px!important;" showFirstLastButtons></mat-paginator>
          </div>
        </div>

      </p-dialog>



      <p-dialog [contentStyle]="{ overflow: 'scroll' }" header="QX Matrix - Failure Mode"
        [(visible)]="displayQualityDefectModal" [style]="{ width: 'auto' }" [maximizable]="true" [baseZIndex]="10000"
        [resizable]="true">
        <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-12">
            <table mat-table class="basic-table basic-table1 plant-model-table dowtime-table" matSort
              [dataSource]="parametrdefect">

              <ng-container matColumnDef="DefectMode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Failure Mode Details</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.defectmode}}</td>
              </ng-container>

              <ng-container matColumnDef="Department">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Department</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.department}}</td>
              </ng-container>

              <ng-container matColumnDef="Assembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Assembly</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.assembly}}</td>
              </ng-container>

              <ng-container matColumnDef="Component">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Component</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.component}}</td>
              </ng-container>

              <ng-container matColumnDef="Subassembly">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Subassembly</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.subassembly}}</td>
              </ng-container>

              <ng-container matColumnDef="Unit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Unit</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.Unit}}</td>
              </ng-container>

              <ng-container matColumnDef="Line">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">Line</p>
                </th>
                <td mat-cell *matCellDef="let element">{{element.Line}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="defectColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: defectColumns"></tr>
            </table>
            <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]"
              style="color:#0f0fd1 !important;border-radius:4px!important;" showFirstLastButtons></mat-paginator> \
          </div>
        </div>

      </p-dialog>
      <ng-template #displayQCModal>
        <div mat-dialog-title>
          <div class="d-flex justify-content-between align-items-center">
            <h2>QC Verify</h2>

            <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
              <i class="fa fa-times" style="color: #fff"></i>
            </button>
          </div>
        </div>
        <mat-dialog-content>
          <mat-form-field appearance="fill" class="field-fill" style="width: 20%; margin-left: 10px;">
            <label>Verifcation Slot</label>
            <input matInput value={{qcParamsSlot}} disabled />

          </mat-form-field>
          <mat-form-field appearance="fill" class="field-fill" style="width: 20%; margin-left: 10px;">
            <label>Process Order No</label>
            <input matInput placeholder="PO" value={{qcheadertooltip}} disabled />

          </mat-form-field>
          <mat-form-field appearance="fill" class="field-fill inputs" style="display: none;">
            <label>Verification Status</label>
            <mat-select [(value)]="verifcationStatus" name="status" placeholder="Select Verification Status">
              <mat-option value="Approve">Approve</mat-option>
              <mat-option value="Reject">Reject</mat-option>
              <mat-option value="Hold">Hold</mat-option>
              <mat-option value="Hold">Downgrade</mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-mini-fab mat-button color="primary" title="Save Verifcation" style="margin-left: 10px;"
            (click)="saveQcVerify()">
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>
          <div class="wrapper-box wrapper-box-shadow table-wrapper">

            <div class="content-row-flex-both-end">

              <table mat-table class="basic-table basic-table1 plant-model-table" matSort [dataSource]="qcdataSource">

                <ng-container matColumnDef="ParameterId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">Parameter Id</p>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.parameterId}}</td>
                </ng-container>

                <ng-container matColumnDef="Parameter">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">Parameter</p>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.parameter}}</td>
                </ng-container>
                <ng-container matColumnDef="Sample">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">Sample</p>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.sample}}</td>
                </ng-container>
                <ng-container matColumnDef="Value">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">Value</p>
                  </th>
                  <td mat-cell *matCellDef="let element">{{element.value}}</td>
                </ng-container>

                <ng-container matColumnDef="verify">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">Verification Status</p>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <select [ngModel]="element.verificationStatus" (change)="verifyChnage(element, $event)"
                      class="tableselect">
                      <option value="Approve">Approve</option>
                      <option value="Reject">Reject</option>
                      <option value="Hold">Hold</option>
                      <option value="Downgrade">Downgrade</option>
                    </select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="remarks">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    <p class="header-text">Remarks</p>
                  </th>
                  <td mat-cell *matCellDef="let element" style="width: 30%;">
                    <mat-form-field appearance="fill" class="field-fill remarks" style="width:100%!important">
                      <input matInput placeholder="Remarks" autocomplete="off"
                        (change)="QcVerifyremarksUpdate(element, $event)" [value]="element.remarks" />
                    </mat-form-field>
                  </td>

                </ng-container>
                <tr mat-header-row *matHeaderRowDef="qcVerifyColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: qcVerifyColumns"></tr>
              </table>
            </div>
            <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>

          </div>

        </mat-dialog-content>

      </ng-template>
      <!-- </mat-expansion-panel> -->
    </div>
  </div>

  <!-- Quality Checklist Execution -->
  <div id="wrapper8">
    <div class="wrapper-box background wrapper-box background-shadow table-wrapper">
      <div class="title">
        <h1>
          {{'QualityChecklistExecution' | translate}}<span>{{selectedunit}}</span>
        </h1>
        <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
          (click)="onPrevious8()">Previous</button>
      </div>
      <div class="content-row-flex-both-end">
        <table mat-table [dataSource]="customerManagementDataSource"
          class="basic-table basic-table1 plant-model-table dowtime-table" matSort>
          <ng-container matColumnDef="listName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'ChecklistName' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.listName}}</td>
          </ng-container>

          <ng-container matColumnDef="Area">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">{{'Area' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.areaName}}</td>
          </ng-container>
          <ng-container matColumnDef="Machine">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">{{'Machine' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.Pu_Desc}}</td>
          </ng-container>

          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">{{'ChecklistType' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.listType}}</td>
          </ng-container>
          <ng-container matColumnDef="TotalExec">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="header-min-width">
              <p class="header-text">{{'TotalNumberOfExecutions' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.noOfExecution}}</td>
          </ng-container>
          <ng-container matColumnDef="LastexecDate">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header
              class="header-min-width">
              <p class="header-text">{{'LastExecutionDate' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.lastExecutionDate | date: "dd/MM/yyyy HH:mm:ss" }}</td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'Action' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">
              <div class="row-action-btns">
                <button (click)="OpenEditCheckList(element , checklistExecutionModal)"
                  [pTooltip]="'ListExecution' | translate" mat-icon-button class="edit-btn" aria-label="List Execution">
                  <svg class="autoFillColor" width="20" height="20" class="svg-icon" viewBox="0 0 20 20">
                    <path fill="white" d="M13.68,9.448h-3.128V6.319c0-0.304-0.248-0.551-0.552-0.551S9.448,6.015,9.448,6.319v3.129H6.319
                      c-0.304,0-0.551,0.247-0.551,0.551s0.247,0.551,0.551,0.551h3.129v3.129c0,0.305,0.248,0.551,0.552,0.551s0.552-0.246,0.552-0.551
                      v-3.129h3.128c0.305,0,0.552-0.247,0.552-0.551S13.984,9.448,13.68,9.448z M10,0.968c-4.987,0-9.031,4.043-9.031,9.031
                      c0,4.989,4.044,9.032,9.031,9.032c4.988,0,9.031-4.043,9.031-9.032C19.031,5.012,14.988,0.968,10,0.968z M10,17.902
                      c-4.364,0-7.902-3.539-7.902-7.903c0-4.365,3.538-7.902,7.902-7.902S17.902,5.635,17.902,10C17.902,14.363,14.364,17.902,10,17.902
                      z"></path>
                  </svg>
                </button>
                <button (click)="OpenViewCheckList(element , displayRoleModalView)" style="background-color: #723ae4;"
                  [pTooltip]="'View Execution'" mat-icon-button class="edit-btn" aria-label="List Execution">
                  <svg class="autoFillColor" width="20" height="20" class="svg-icon" viewBox="0 0 20 20">
                    <path fill="white"
                      d="M19.471,8.934L18.883,8.34c-2.096-2.14-4.707-4.804-8.903-4.804c-4.171,0-6.959,2.83-8.996,4.897L0.488,8.934c-0.307,0.307-0.307,0.803,0,1.109l0.401,0.403c2.052,2.072,4.862,4.909,9.091,4.909c4.25,0,6.88-2.666,8.988-4.807l0.503-0.506C19.778,9.737,19.778,9.241,19.471,8.934z M9.98,13.787c-3.493,0-5.804-2.254-7.833-4.3C4.182,7.424,6.493,5.105,9.98,5.105c3.536,0,5.792,2.301,7.784,4.332l0.049,0.051C15.818,11.511,13.551,13.787,9.98,13.787z">
                    </path>
                    <circle fill="white" cx="9.98" cy="9.446" r="1.629"></circle>
                  </svg>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="customerManagementColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: customerManagementColumns" (click)="highlight(row)"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center;" colspan="4">{{'NoDataFound' | translate}}</td>
          </tr>
        </table>
      </div>

      <mat-paginator class="basic-paginataor" style="background: #bfbff5;" [pageSizeOptions]="[ 5, 10, 20]"
        showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
  <!-- CIL Management Starts Here -->
  <div id="wrapper9">
    <div class="wrapper-box background wrapper-box background-shadow table-wrapper">
      <div class="title">
        <h1>
          {{'CILManagement' | translate}}<span>{{selectedunit}}</span>
        </h1>
        <button mat-raised-button style="background-color: #190FD1; height: 40px;" color="warn" type="button"
          (click)="onPrevious8()">Previous</button>
      </div>

      <!-- CIL MANAGEMENT STARTS HERE -->

      <div class="cli-management-content">
        <div class="content-top-box">
          <div class="tab-content-top-box">
            <!-- <h1 class="main-title">CIL Management</h1> -->
          </div>
        </div>

        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />">
          <p style="color: white">Fetching Data...</p>
        </ngx-spinner>

        <form [formGroup]="CilManagDataForm">
          <div class="wrapper-box wrapper-box-shadow table-wrapper">
            <div class="content-top-row">

              <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing">
                <mat-label>Assembly</mat-label>
                <mat-select formControlName="assembly" (selectionChange)="getComponents()">
                  <mat-select-filter [placeholder]="'Search'" [displayMember]="'Asmb_Desc'" [array]="assembly"
                    (filteredReturn)="filteredAssembly = $event"></mat-select-filter>
                  <mat-option *ngFor="let a of filteredAssembly" [value]="a.Asmb_Id">
                    {{ a.Asmb_Desc }}</mat-option>

                </mat-select>
              </mat-form-field>
              <mat-form-field appearence="fill" class="top-row-first-filed-item width" style="margin-left: 14px">
                <mat-label>Component</mat-label>
                <mat-select formControlName="component" (selectionChange)="getDefectMgmtTableData()">
                  <mat-select-filter [placeholder]="'Search'" [displayMember]="'ComponentName'" [array]="components"
                    (filteredReturn)="filteredcomponents = $event"></mat-select-filter>
                  <mat-option [value]="0">ALL</mat-option>
                  <mat-option *ngFor="let k of filteredcomponents" [value]="k.ComponentId">
                    {{ k.ComponentName }}</mat-option>
                </mat-select>
              </mat-form-field>
              <button type="button" mat-mini-fab mat-button mat-dialog-close color="primary" pTooltip="Refresh"
                tooltipPosition="top" style="margin-left: 10px;" (click)="getDefectMgmtTableData()">
                <i class="fa fa-refresh" style="color: #fff"></i>
              </button>

            </div>

          </div>
        </form>
        <div class="content-top-row" style="display: flex;justify-content: space-between;">
          <button mat-flat-button color="accent" (click)=" openCILExecformModel()" class="btn-accent-big"
            style="margin-left: 80px" [disabled]="isButtonEnable">
            Execute
          </button>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="background-color:#000;">
            <mat-label style="color: #fff">Search</mat-label>
            <input id="search" matInput (keyup)="applyFilter($event)" autocomplete="off" />
          </mat-form-field>

        </div>
        <!-- Table -->


        <div style="margin-top: 20px;">
          <!--table-->

          <mat-tab-group animationDuration="0ms">
            <mat-tab label="Non Executed">
              <div class="content-row-flex-both-end">
                <!--table-->


                <table mat-table [dataSource]="cilManagementVariableGroupData" class="basic-table plant-model-table"
                  matSort>
                  <!-- ID Column -->
                  <ng-container matColumnDef="isChecked">

                    <th mat-header-cell *matHeaderCellDef>
                      <mat-checkbox (change)="$event ? masterToggle(): null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                      </mat-checkbox>

                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)" [disabled]="row.submitted " *ngIf="row.Executable">
                      </mat-checkbox>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="task">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Task : ('Task' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.taskName}}</td>
                  </ng-container>

                  <!-- Type Column -->
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Type : ('Type' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.cilTypeName}}</td>
                  </ng-container>

                  <!-- Unit Column -->
                  <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Unit : ('Unit' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.machineName}}</td>
                  </ng-container>

                  <!-- Component Column -->
                  <ng-container matColumnDef="component">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Component : ('Component' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.componentName}}</td>
                  </ng-container>

                  <!-- Frequency Column -->
                  <ng-container matColumnDef="frequency">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Frequency : ('Frequency' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.cilFrequencyName}}</td>
                  </ng-container>

                  <!-- Next Time Column -->
                  <ng-container matColumnDef="nexttime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.ExpiryDate : ('Expiry Date' | translate)}}</p>
                      <!-- <p class="header-text">{{langObj ? langObj?.NextTime : ('NextTime' | translate)}}</p> -->
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.expiryDate | date: "dd/MM/yyyy HH:mm:ss"}}</td>
                  </ng-container>
                  <ng-container matColumnDef="image">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PreImage : ('PreImage' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <!-- {{element.preTaskImage}} -->
                      <img class="image"
                        [src]="(element.preTaskImage === null || element.preTaskImage === '' || element.preTaskImage === undefined) ? 'assets/images/no-image.png': element.preTaskImage"
                        style="width: 40px; height: 40px;"
                        (click)="imageZoomModal((element.preTaskImage === null || element.preTaskImage === '' || element.preTaskImage === undefined)  ? 'assets/images/no-image.png': element.preTaskImage)" />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="remarks">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PreRemarks : ('PreRemarks' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.remarks}}</td>
                  </ng-container>
                  <ng-container matColumnDef="postRemarks">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PostRemarks : ('PostRemarks' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.postRemarks}}</td>
                  </ng-container>
                  <!-- {{ELEMENT.taskImage}}-->
                  <ng-container matColumnDef="postImage">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PostImage : ('PostImage' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <!-- {{element.preTaskImage}} -->
                      <img class="postImage"
                        [src]="(element.taskImage === null || element.taskImage === '' || element.taskImage === undefined) ? 'assets/images/no-image.png': element.taskImage"
                        style="width: 40px; height: 40px;"
                        (click)="imageZoomModal((element.taskImage === null || element.taskImage === '' || element.taskImage === undefined) ? 'assets/images/no-image.png': element.taskImage)" />
                    </td>
                  </ng-container>
                  <!-- SOP/OPL Column -->
                  <ng-container matColumnDef="sop">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.sopopl : ('sopopl' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <a target="_blank" *ngIf="element.sop !== ''" class="btn" [href]="element.sop"
                        style="width:100%"><i class="fa fa-download"></i> </a>
                    </td>
                  </ng-container>

                  <!-- Action Column -->
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Action : ('Action' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <button *ngIf="IsWrite && element.Executable " mat-icon-button class="edit-btn"
                        aria-label="Edit Row" [disabled]="element.submitted || !element.Executable"
                        (click)=" openCILPerformModel(element)">
                        <img [src]="editIconurl" alt="{{editIconurl}}" />
                      </button>
                      <button class="view-btn" pTooltip="View Responsible" tooltipPosition="top"
                        aria-label="View Responsible" (click)="ViewResponsible(element)">
                        <svg class="svg-icon" viewBox="0 0 20 20">
                          <path
                            d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z"
                            fill="white"></path>
                        </svg>
                      </button>

                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="cilmanagementColumns"></tr>
                  <!-- <tr mat-row *matRowDef="let row; columns: cilmanagementColumns;" matRipple class="element-row" ></tr> -->
                  <tr mat-row *matRowDef="let row; columns: cilmanagementColumns;" matRipple class="element-row"
                    (click)="!row.submitted  &&   row.Executable === true? selection.toggle(row) : ''"
                    [ngStyle]="row.Executable === false? {'background-color': 'rgb(255 203 215)'} : {'background-color': '#8ee685'}"
                    [pTooltip]='row.expiryDate | date: "dd/MM/yyyy HH:mm:ss" '>
                    <div style="text-align: center;" *ngIf="cilManagementVariableGroupData.filteredData.length === 0">
                      {{langObj
                      ?
                      langObj?.norecfnd : ('norecfnd' | translate)}}</div>

                </table>
              </div>
              <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]" showFirstLastButtons>
              </mat-paginator>
            </mat-tab>
            <mat-tab label="Executed">
              <div class="content-row-flex-both-end">
                <!--table-->


                <table mat-table [dataSource]="cilManagementExecuted" class="basic-table plant-model-table" matSort>
                  <!-- ID Column -->
                  <ng-container matColumnDef="isChecked">

                    <th mat-header-cell *matHeaderCellDef>

                    </th>
                    <td mat-cell *matCellDef="let row">

                    </td>
                  </ng-container>

                  <ng-container matColumnDef="task">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Task : ('Task' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.taskName}}</td>
                  </ng-container>

                  <!-- Type Column -->
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Type : ('Type' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.cilTypeName}}</td>
                  </ng-container>
                  <!-- Unit Column -->
                  <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Unit : ('Unit' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.machineName}}</td>
                  </ng-container>

                  <!-- Component Column -->
                  <ng-container matColumnDef="component">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Component : ('Component' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.componentName}}</td>
                  </ng-container>

                  <!-- Frequency Column -->
                  <ng-container matColumnDef="frequency">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.Frequency : ('Frequency' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.cilFrequencyName}}</td>
                  </ng-container>

                  <!-- Next Time Column -->
                  <ng-container matColumnDef="nexttime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.NextTime : ('NextTime' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.nextTime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
                  </ng-container>
                  <ng-container matColumnDef="image">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PreImage : ('PreImage' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <!-- {{element.preTaskImage}} -->
                      <img class="image"
                        [src]="(element.preTaskImage === null || element.preTaskImage === '' || element.preTaskImage === undefined) ? 'assets/images/no-image.png': element.preTaskImage"
                        style="width: 40px; height: 40px;"
                        (click)="imageZoomModal((element.preTaskImage === null || element.preTaskImage === '' || element.preTaskImage === undefined)  ? 'assets/images/no-image.png': element.preTaskImage)" />
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="remarks">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PreRemarks : ('PreRemarks' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.remarks}}</td>
                  </ng-container>
                  <ng-container matColumnDef="postRemarks">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PostRemarks : ('PostRemarks' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.postRemarks}}</td>
                  </ng-container>
                  <!-- {{ELEMENT.taskImage}}-->
                  <ng-container matColumnDef="postImage">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.PostImage : ('PostImage' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <!-- {{element.preTaskImage}} -->
                      <img class="postImage"
                        [src]="(element.taskImage === null || element.taskImage === '' || element.taskImage === undefined) ? 'assets/images/no-image.png': element.taskImage"
                        style="width: 40px; height: 40px;"
                        (click)="imageZoomModal((element.taskImage === null || element.taskImage === '' || element.taskImage === undefined) ? 'assets/images/no-image.png': element.taskImage)" />
                    </td>
                  </ng-container>
                  <!-- SOP/OPL Column -->
                  <ng-container matColumnDef="sop">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.sopopl : ('sopopl' | translate)}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <a target="_blank" *ngIf="element.sop !== ''" class="btn" [href]="ImageUrl+element.sop"
                        style="width:100%"><i class="fa fa-download"></i> </a>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="lastExecutedDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{langObj ? langObj?.LastExecutedDate : ('LastExecutedDate' | translate)}}
                      </p>
                    </th>
                    <td mat-cell *matCellDef="let element">{{element.LastExecutedDate | date: "dd/MM/yyyy HH:mm:ss"}}
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="executedCilmanagementColumns"></tr>
                  <!-- <tr mat-row *matRowDef="let row; columns: cilmanagementColumns;" matRipple class="element-row" ></tr> -->
                  <tr mat-row *matRowDef="let row; columns: executedCilmanagementColumns;" matRipple class="element-row"
                    (click)="!row.submitted && selection.toggle(row)"
                    [ngStyle]="row.submitted && {'background-color': 'lightgrey'}">
                    <div style="text-align: center;" *ngIf="cilManagementExecuted.filteredData.length === 0">{{langObj ?
                      langObj?.norecfnd : ('norecfnd' | translate)}}</div>

                </table>
              </div>
              <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]" showFirstLastButtons>
              </mat-paginator>
            </mat-tab>
          </mat-tab-group>



          <!-- Perform Action CIL row model -->
          <div class="sidepanel-model-wrapper edit-plant-row-model" [ngClass]="{'active': isEditCILModelVisible}">
            <div class="sidepanel-close" (click)="closeaddNewVariableModel()"></div>
            <div class="model-content">
              <div class="model-top">
                <h2 class="model-title">CIL Management</h2>
                <button mat-icon-button class="model-close-btn" aria-label="Close model"
                  (click)="closeCILPerformModel()">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
                      fill="black" />
                  </svg>
                </button>
              </div>
              <div class="model-body">
                <form [formGroup]="performCILItemForm" (ngSubmit)="formMode ? saveCilAction():SavePerformTask()">
                  <div class="form-group">
                    <mat-radio-group aria-label="Select an option" formControlName="option">
                      <mat-radio-button value="Done">Done</mat-radio-button>
                      <mat-radio-button value="NotDone" style="margin-left: 16px;">Not Done</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div class="form-group">
                    <mat-form-field appearance="fill" class="field-fill-with-icon">
                      <mat-label>Start Time</mat-label>
                      <input [readonly]="true" matInput [ngxMatDatetimePicker]="startPicker1"
                        formControlName="startDate">
                      <mat-datepicker-toggle matSuffix [for]="$any(startPicker1)"></mat-datepicker-toggle>
                      <ngx-mat-datetime-picker #startPicker1>
                      </ngx-mat-datetime-picker>
                    </mat-form-field>
                  </div>
                  <div class="form-group">
                    <mat-form-field appearance="fill" class="field-fill-with-icon">
                      <mat-label>End Time</mat-label>
                      <input [readonly]="true" matInput [ngxMatDatetimePicker]="startPicker2" formControlName="endDate">
                      <mat-datepicker-toggle matSuffix [for]="$any(startPicker2)"></mat-datepicker-toggle>
                      <ngx-mat-datetime-picker #startPicker2>
                      </ngx-mat-datetime-picker>
                    </mat-form-field>
                  </div>

                  <div class="form-group">
                    <mat-form-field appearance="fill" class="field-fill">
                      <mat-label>Remarks</mat-label>
                      <input required matInput placeholder="Remarks" formControlName="Remarks">
                    </mat-form-field>
                  </div>
                  <div class="custom-dropzone" ngx-dropzone [accept]="'image/*'" (change)="onFileSelect($event)"
                    [multiple]="false" *ngIf="!formMode">
                    <ngx-dropzone-label>
                      <div>
                        <h2>Upload Image</h2>
                      </div>
                    </ngx-dropzone-label>
                    <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" *ngIf="file" [file]="file"
                      [removable]="true" (removed)="onRemove(file)">
                      <ngx-dropzone-label>{{ file.name }} ({{ file.type }})</ngx-dropzone-label>
                    </ngx-dropzone-image-preview>
                  </div>
                  <div class="model-form-actions">
                    <button type="button" mat-flat-button class="btn-cancel" (click)="closeCILPerformModel()">
                      Cancel
                    </button>
                    <!-- <button type="submit" mat-flat-button color="accent" class="btn-accent" (click)="SaveNewDefect()"> Save </button> -->
                    <button [disabled]="!performCILItemForm.valid" type="submit" mat-flat-button color="accent"
                      *ngIf="IsWrite" class="btn-accent"> Save </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <ng-template #imageZoomModel>

          <img [src]="currentImagePath" style="height: 98%;width: 100%; overflow: hidden;">

        </ng-template>

        <!-- CIL MANAGEMENT ENDS HERE -->
      </div>
    </div>
    <!-- CIL Management End Here -->
  </div>

  <!--side bar modal code-->
  <div class="sidepanel-model-wrapper edit-plant-row-model" [ngClass]="{ active: displayUserModal }">
    <div class="sidepanel-close" (click)="closeaddNewPlantItemModel()"></div>
    <div class="model-content">
      <div class="model-top">
        <h2 class="model-title">{{'Group' | translate}} {{'Structure' | translate}}</h2>
        <button mat-icon-button class="model-close-btn" aria-label="Close model" (click)="closeaddNewPlantItemModel()">
          <svg class="autoFillColor" width="14" height="12" viewBox="0 0 14 14" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.46 7L14 12.54V14H12.54L7 8.46L1.46 14H0V12.54L5.54 7L0 1.46V0H1.46L7 5.54L12.54 0H14V1.46L8.46 7Z"
              fill="black" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <!-- </div> -->

  <!-- plant group view model -->

  <ng-template #checklistExecutionModal>

    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>{{langObj ? langObj?.ChecklistExecution : ('ChecklistExecution' | translate)}}</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <form [formGroup]="checklistDataForm">
      <mat-dialog-content>
        <div class="content-top-row content-top-row-order-processing checklist_modal">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px;">
            <mat-label class="required">{{ langObj ? langObj?.ChecklistType : ('ChecklistType' | translate) }}
            </mat-label>
            <input matInput formControlName="checktype" placeholder="Enter List Type" readonly />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label class="required">{{ langObj ? langObj?.ChecklistName : ('ChecklistName' | translate) }}
            </mat-label>
            <input matInput formControlName="checkname" placeholder="Enter List Name" readonly />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{ langObj ? langObj?.Area : ('Area' | translate) }}</mat-label>
            <input matInput formControlName="area" placeholder="Enter area Name" readonly />
            <mat-error>{{langObj ? langObj?.PleaseSelect : ('PleaseSelect' | translate)}} {{ langObj ? langObj?.Area :
              ('Area' | translate) }}</mat-error>
          </mat-form-field>
          <div class="inputField checklisttime" style="width: 295px;">
            <nz-date-picker (ngModelChange)="getDateShifts()" class="calender-input sfdcCalender-input"
              style="background: white;border-radius: 4px;" formControlName="executionDate" id="timePicker1"
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true">
            </nz-date-picker>
            <span class="floating-text">{{ langObj ? langObj?.Date : ('Date' | translate) }}</span>
          </div>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label class="required">{{langObj ? langObj?.Shift : ('Shift' | translate)}}</mat-label>
            <input matInput formControlName="shiftName" readonly />

          </mat-form-field>
          <input formControlName="shift" style="display: none;" readonly placeholder="Shift" />
        </div>
        <div class="content-top-row content-top-row-order-processing checklist_modal">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px;">
            <mat-label>{{langObj ? langObj?.Previous : ('Previous' | translate)}} {{langObj ? langObj?.ProcessOrderNo :
              ('ProcessOrderNo' | translate)}}</mat-label>
            <input matInput formControlName="previousProcessOrder" [readonly]="isAuto2" />
            <input matInput formControlName="previousProcessOrderId" style="display: none;" [readonly]="isAuto2" />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.Previous : ('Previous' | translate)}} {{langObj ? langObj?.ProductName :
              ('ProductName' | translate)}}</mat-label>
            <input matInput placeholder="Product Description" formControlName="previousProductName"
              [readonly]="preAuto2" />
          </mat-form-field>
        </div>
      </mat-dialog-content>

      <mat-divider></mat-divider>
      <div style="margin-top: 10px;"></div>

      <table mat-table [dataSource]="checkListAddModel" class="basic-table plant-model-table popup" matSort>
        <ng-container matColumnDef="items">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.Items : ('Items' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element" class="td-text" style="padding-left: 80px; width: 30%;">
            {{element.itemName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="good">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style=" padding-left: 0px;">
            <p class="header-text">{{langObj ? langObj?.GoodExample : ('GoodExample' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="width: 10%;">

            <img [src]="element.goodExampleImage!== '' ? element.goodExampleImage:'assets/images/no-image.png'"
              width="30px" height="30px"
              (click)="imageZoomModal(element.goodExampleImage!== '' ? element.goodExampleImage:'assets/images/no-image.png')">
          </td>
        </ng-container>


        <ng-container matColumnDef="bad">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 0px;">
            <p class="header-text">{{langObj ? langObj?.BadExample : ('BadExample' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element; let i = index" style="width: 10%;">
            <img [src]="element.badExampleImage!== '' ? element.badExampleImage:'assets/images/no-image.png'"
              width="30px" height="30px"
              (click)="imageZoomModal(element.badExampleImage!== '' ? element.badExampleImage:'assets/images/no-image.png')">
          </td>
        </ng-container>

        <ng-container matColumnDef="standard">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Standard</p>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 10%;">
            {{ element.standard }}
          </td>
        </ng-container>

        <ng-container matColumnDef="minimum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Min</p>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 5%;">
            {{ element.minValue }}
          </td>
        </ng-container>

        <ng-container matColumnDef="maximum">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">Max</p>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 5%;">
            {{ element.maxValue }}
          </td>
        </ng-container>

        <ng-container matColumnDef="score">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{langObj ? langObj?.Result : ('Result' | translate)}}</p>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 30%;  background-color: #edf1e5;">

            <mat-radio-group required aria-label="Select an option" [value]="element.score"
              (change)="scoreUpdate($event, element); onChangeradio($event) " *ngIf="element.itemType === 1">
              <mat-radio-button *ngFor="let p of categoryTypeDDL" [value]="p.id" style="margin-left: 10px;">{{p.name}}
              </mat-radio-button>
            </mat-radio-group>

            <mat-form-field appearance="fill" class="score field-fill-table " *ngIf="element.itemType === 2"
              style="width: 180px;">
              <input matInput autocomplete="off" (change)="scoreUpdate($event, element)" [value]="element.score">
            </mat-form-field>
            <div appearance="fill" class="field-fill" *ngIf="element.itemType === 4" style="width: 180px;">
              <input [placeholder]="langObj ? langObj?.UploadFile : ('UploadFile' | translate)" type="file"
                (change)="uploadedFile($event, element.checkListDetailId)" class="form-control" accept=".png, .jpg" />

            </div>
            <mat-form-field appearence="fill" class="field-fill" *ngIf="element.itemType === 3">
              <mat-label class="placeholder-title">{{langObj ? langObj?.FromDate : ('FromDate' | translate)}}
              </mat-label>
              <input matInput [matDatepicker]="pickerspoedit" (dateInput)="onDateChange($event, element)"
                style="width: 180px;" [readonly]="true">
              <mat-datepicker-toggle matSuffix [for]="pickerspoedit"></mat-datepicker-toggle>
              <mat-datepicker #pickerspoedit></mat-datepicker>
            </mat-form-field>

            <mat-form-field apearence="fill" class="field-fill" *ngIf="element.itemType === 5" style="width: 100%;">
              <mat-label>Select an option</mat-label>
              <mat-select [value]="element.CatType" (selectionChange)="OnDropdownUpdate($event,element)">
                <mat-option *ngFor="let data of element.dropDown"
                  [value]="data.ElementValue">{{data.ElementValue}}</mat-option>

              </mat-select>

            </mat-form-field>
          </td>

        </ng-container>
        <ng-container matColumnDef="remarks">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <p class="header-text">{{ langObj ? langObj?.Remarks: ('Remarks' | translate) }}</p>
          </th>
          <td mat-cell *matCellDef="let element" style="width: 30%;  background-color: #edf1e5;">
            <mat-form-field appearance="fill" class="field-fill-table" style="width:100% ;">
              <input matInput [placeholder]="langObj ? langObj?.Remarks: ('Remarks' | translate)" autocomplete="off"
                (change)="remarksUpdate($event, element)" [value]="element.remarks">
            </mat-form-field>
          </td>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
        <tr class="mat-row" *matNoDataRow style="text-align: center;">
          <td class="mat-cell" style="text-align: center;" colspan="7">{{langObj ? langObj?.NoDataFound : ('NoDataFound'
            | translate)}}</td>
        </tr>


        <!-- Group header -->
        <ng-container matColumnDef="groupHeader">
          <th (click)="groupHeaderClick(group)" colspan="999" mat-header-cell *matCellDef="let group"
            class="group-header">
            <div class="d-flex align-items-center">
              <mat-icon *ngIf="group.expanded">arrow_drop_down</mat-icon>
              <mat-icon *ngIf="!group.expanded">arrow_right</mat-icon>
              <span class="table-group-title">{{group[groupByColumns[group.level-1]]}}</span>
            </div>
          </th>
        </ng-container>
        <tr mat-header-row *matRowDef="let group; columns: ['groupHeader'];when: isGroup"></tr>
        <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"> </mat-row>

      </table>
      <div mat-dialog-actions style="float: right; margin-top: 10px">
        <button mat-mini-fab mat-button color="primary" (click)="addCheckListExecution()" *ngIf="IsWrite">
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </form>

  </ng-template>
  <!-- History Batch Modal -->
  <ng-template #historyBatchModal *ngIf="machineSelectProperty">


    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{ langObj ? langObj?.HistoryBatch : ('HistoryBatch' | translate) }}</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <mat-card-content>
        <ag-grid-angular style="width: 100%; height: 30vw" class="ag-theme-alpine" [rowData]="rowDataBatchHistory"
          [columnDefs]="columnBatchHistory" [defaultColDef]="defaultColDefinition"
          (gridReady)="onGridReadyForBatchHistory($event)" [frameworkComponents]="frameworkComponents"
          [loadingOverlayComponent]="loadingOverlayComponent"
          [loadingOverlayComponentParams]="loadingOverlayComponentParams" [gridOptions]="gridOptionsBatchHistory"
          [pagination]="true" [paginationPageSize]="10" (cellClicked)='onCellProductionClicked($event)'>
        </ag-grid-angular>
      </mat-card-content>
    </mat-dialog-content>

  </ng-template>
  <ng-template #historyMaterialModal *ngIf="machineSelectProperty">


    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{ langObj ? langObj?.HistoryMaterialConsumption : ('HistoryMaterialConsumption' | translate) }}</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <mat-card-content>
        <ag-grid-angular style="width: 100%; height: 30vw;" class="ag-theme-alpine"
          [rowData]="rowDataMaterialConsumptionHistory" [columnDefs]="columnMaterialConsumptionHistory"
          (gridReady)="onGridReady($event)" [frameworkComponents]="frameworkComponents" [gridOptions]="gridOptions"
          [pagination]="true" [paginationPageSize]="10">
        </ag-grid-angular>
      </mat-card-content>
    </mat-dialog-content>

  </ng-template>

  <!--popup modal for production checklist history-->
  <ng-template #popupViewModal>
    <div class="viewChecklist">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{'ChecklistHistoryView' | translate}}</h2>
          <button mat-raised-button mat-dialog-close color="warn" title="close">
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <div [ngClass]="ViewProductionOutputDataSource !== undefined ? 'table-overflow': ''">
        <table [dataSource]="ViewProductionOutputDataSource" mat-table
          class="popup_color basic-table basic-table1 plant-model-table theight" matSort>
          <!-- Checklist Column -->
          <ng-container matColumnDef="checklist">
            <th mat-header-cell mat-sort-header-pointer-middle *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'Checklist' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Name}}</td>
          </ng-container>

          <!-- Values Column -->
          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{'Values' | translate}}</p>
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <input *ngIf="element.DataType === 'bool' && element.BatchCheckListValue === 'true'" [checked]="true"
                type="checkbox" (change)="checkListFunction(element.BatchCheckListTypeId, $event)" color="primary"
                [readonly]="true">
              <input *ngIf="element.DataType === 'bool' && element.BatchCheckListValue !== 'true'" type="checkbox"
                (change)="checkListFunction(element.BatchCheckListTypeId, $event)" color="primary" [readonly]="true">
              <input *ngIf="element.DataType === 'string'" type="text"
                [value]="element.BatchCheckListValue === undefined ? '' : element.BatchCheckListValue"
                (change)="checkListFunction(element.BatchCheckListTypeId, $event)" [readonly]="true">
              <input *ngIf="element.DataType === 'number'" type="number" [value]="element.BatchCheckListValue"
                (change)="checkListFunction(element.BatchCheckListTypeId, $event)" [readonly]="true">
              <input type="text" appearance="fill" class="field-fill" style="width: 180px;"
                *ngIf="element.DataType === 'dropdown'" [value]="element.BatchCheckListValue" [disabled]="true">
              <mat-form-field appearance="fill" class="field-fill" *ngIf="element.DataType === 'date'"
                style="width: 180px;">
                <input matInput [matDatepicker]="pickers" [value]="element.BatchCheckListValue"
                  (dateInput)="checkListFunction(element.BatchCheckListTypeId, $event)" [readonly]="true" />
                <mat-datepicker-toggle matSuffix [for]="pickers"></mat-datepicker-toggle>
                <mat-datepicker #pickers></mat-datepicker>
              </mat-form-field>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="productionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: productionColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="8">{{'NoDataFound' | translate}}</td>
          </tr>
        </table>
      </div>
    </div>
  </ng-template>

  <!-- History Batch Material Consumption Modal -->
  <ng-template #historyBatch1Modal *ngIf="machineSelectProperty">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{ langObj ? langObj?.HistoryBatch : ('HistoryBatch' | translate) }}</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <ag-grid-angular style="width: 100%;" class="ag-theme-alpine" [rowData]="rowDataMaterialBatchHistory"
        [columnDefs]="columnMaterialBatchHistory" [defaultColDef]="defaultColDefinition"
        (gridReady)="onGridReady($event)" [frameworkComponents]="frameworkComponents" [gridOptions]="gridOptions"
        [pagination]="true" [paginationPageSize]="10">
      </ag-grid-angular>
    </mat-dialog-content>
  </ng-template>

  <ng-template #centerlineModal *ngIf="machineSelectProperty">
    <div mat-dialog-title style="margin: 0 0 0px">
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{'ProcessParameters' | translate}}</h2>
        <button mat-raised-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="p-grid p-fluid">
        <div class="p-xl-12 p-lg-12 p-md-12 p-col-12">
          <div class="">
            <div class="p-grid p-fluid" style="margin-top: -0.9rem;">
              <div class="p-xl-4 p-lg-4 p-md-4 p-12">
                <table mat-table id="chkId" [dataSource]="processparameter1DataSource"
                  class="basic-table basic-table1 plant-model-table dowtime-table" matSort>
                  <!-- Process Parameter Column -->
                  <ng-container matColumnDef="processparameter">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 12px;">
                      <p class="header-text">{{'ProcessParameter' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" style="max-width:0px;">{{element?.KpiName}}</td>
                  </ng-container>
                  <ng-container matColumnDef="values">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{'Values' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" style="padding-left: 0px;">
                      <mat-form-field appearance="fill" class="field-fill" style="width: 200px;">
                        <input (change)="checkListFunctionForProcess(element, $event)" [value]="element?.KpiValues"
                          matInput class="materialParameterInputs" />
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="processparameter1Columns"></tr>
                  <tr mat-row *matRowDef="let row; columns: processparameter1Columns"></tr>
                  <tr class="mat-row" *matNoDataRow style="text-align: center;">
                    <td class="mat-cell" colspan="8">{{'NoDataFound' | translate}}</td>
                  </tr>
                </table>
              </div>
              <div class="p-xl-4 p-lg-4 p-md-4 p-12">
                <table mat-table [dataSource]="processparameter22DataSource"
                  class="basic-table basic-table1 plant-model-table" matSort>
                  <!-- Process Parameter Column -->
                  <ng-container matColumnDef="materialparameter">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 12px;">
                      <p class="header-text">{{'MaterialParameter' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" style="max-width:0px;">{{element?.KpiName}}</td>
                  </ng-container>
                  <!-- Values Column -->
                  <ng-container matColumnDef="values">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{'Values' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <mat-form-field appearance="fill" class="field-fill" style="width: 200px;">
                        <input (change)="checkListFunctionMaterial(element, $event)" [value]="element?.KpiValues"
                          matInput class="materialParameterInputs" />
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="processparameter2Columns"></tr>
                  <tr mat-row *matRowDef="let row; columns: processparameter2Columns"></tr>
                  <tr class="mat-row" *matNoDataRow style="text-align: center;">
                    <td class="mat-cell" colspan="8">{{'NoDataFound' | translate}}</td>
                  </tr>
                </table>
              </div>
              <div class="p-xl-4 p-lg-4 p-md-4 p-12">
                <table mat-table [dataSource]="processparameter33DataSource"
                  class="basic-table basic-table1 plant-model-table" matSort>
                  <!-- Process Parameter Column -->
                  <ng-container matColumnDef="lineclearance">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{'LineClearence' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element" style="max-width:300px;">{{element?.KpiName}}</td>
                  </ng-container>
                  <!-- Values Column -->
                  <ng-container matColumnDef="values">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <p class="header-text">{{'Values' | translate}}</p>
                    </th>
                    <td mat-cell *matCellDef="let element"><input type="checkbox" [checked]="element.KpiValues"
                        (change)="checkListFunctionLine(element, $event)" color="primary"></td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="processparameter3Columns"></tr>
                  <tr mat-row *matRowDef="let row; columns: processparameter3Columns"></tr>
                  <tr class="mat-row" *matNoDataRow style="text-align: center;">
                    <td class="mat-cell" colspan="8">{{'NoDataFound' | translate}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <div mat-dialog-actions style="float: right">
      <button (click)="SumbitJobKpiParameters1($event)" type="submit" *ngIf="!materialConsumptionMode"
        [disabled]="!materialConsumptionForm.valid" mat-raised-button color="primary"
        [matTooltip]="'Update' | translate" matTooltipClass="custom-tooltip" matTooltipPosition="above">
        <i class="fa fa-pencil" style="color: #fff"></i>
      </button>
      <button (click)="SumbitJobKpiParameters($event)" type="submit" *ngIf="centerLineMode" mat-raised-button
        color="primary" [matTooltip]="'Save' | translate" matTooltipClass="custom-tooltip" matTooltipPosition="above">
        <i class="fa fa-floppy-o" style="color: #fff"></i>
      </button>
    </div>
  </ng-template>
  <ng-template #wastehistoryModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="modal">{{'WasteHistoryDetail' | translate}}</h2>
        <button mat-raised-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <mat-dialog-content>
        <mat-card-content>
          <ag-grid-angular style="width: 100%;" class="ag-theme-alpine" [rowData]="rowDataWasteHistory"
            [columnDefs]="columnWasteHistry" (gridReady)="onGridReady($event)"
            [frameworkComponents]="frameworkComponents" [gridOptions]="gridOptions" [pagination]="true"
            [paginationPageSize]="10" (gridSizeChanged)="onGridSizeChanged($event)">
          </ag-grid-angular>
        </mat-card-content>
      </mat-dialog-content>
    </mat-dialog-content>
  </ng-template>
  <ng-template #displayRoleModal>
    <!-- *ngIf="onlymachineSelectProperty"> -->
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="modal">{{'DownTimeHistory' | translate}}</h2>
        <button mat-raised-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <mat-card-content>
        <ag-grid-angular style="width: 100%;" class="ag-theme-alpine" [rowData]="rowDataDowntimeHistory"
          [columnDefs]="columnDefsDowntimeHistory" (gridReady)="onGridReady($event)"
          (cellClicked)="onClickDowntimeHistory($event)" [frameworkComponents]="frameworkComponents"
          [gridOptions]="gridOptions" [pagination]="true" [rowSelection]="true" [paginationPageSize]="10">
        </ag-grid-angular>
      </mat-card-content>
    </mat-dialog-content>
  </ng-template>
  <ng-template #displayPoModal>

    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{'HistoryProcessOrders' | translate}}</h2>
        <button mat-raised-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <!--table-->
      <mat-card-content>
        <ag-grid-angular class="historyGrid" style="width: 100%;" class="ag-theme-alpine" id="myGrid"
          [rowData]="rowData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)"
          [frameworkComponents]="frameworkComponents" [gridOptions]="gridOptions" [pagination]="true"
          [paginationPageSize]="5">
        </ag-grid-angular>
      </mat-card-content>
    </mat-dialog-content>

  </ng-template>
  <ng-template #lastshiftModal *ngIf="onlymachineSelectProperty">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{'Last' | translate}} {{'Shift' | translate}}</h2>
        <button mat-raised-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="p-grid p-fluid">
        <div class="p-xl-12 p-lg-12 p-md-12 p-col-12">
          <div class="content-row-flex-both-end">
            <div class="card-item card-item-five" style="max-width: 39%;">
              <div class="card" style="display: flex; width:424px; height: 230px;">
                <img src="assets/images/user.png" alt="" width="170px" height="200px" style="margin: 0;">
                <o3-percentage-graph></o3-percentage-graph>
                <div style="margin-left: 10px; margin-top: 0px">
                  <h2 style="margin-left: 15px;">{{UserName}}</h2>
                  <div style="display: flex;margin-top: -20px;">
                    <div style="width: 100%;">
                      <h3 class="graph-title">{{'Shift' | translate}}:</h3>
                      <h3 class="graph-title">{{'Shift' | translate}} {{'Start' | translate}}:</h3>
                      <h3 class="graph-title">{{'Shift' | translate}} {{'End' | translate}}:</h3>
                      <h3 class="graph-title">{{'Supervisor' | translate}}:</h3>
                    </div>
                    <div style="width: 70%;">
                      <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after"
                        matBadgeColor="accent" MatBadgeSize="large" disableRipple style="margin-left: 14px;"
                        *ngIf="Shift !== ''">
                        <p class="badge-text">
                          {{Shift}}
                        </p>
                      </button>
                      <br>
                      <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after"
                        matBadgeColor="accent" MatBadgeSize="large" disableRipple style="margin-left: 14px;"
                        *ngIf="ShiftStart !== ''">
                        <p class="badge-text">{{ShiftStart}}</p>
                      </button>
                      <br>
                      <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after"
                        matBadgeColor="accent" MatBadgeSize="large" disableRipple style="margin-left: 14px;"
                        *ngIf="ShiftEnd !== ''">
                        <p class="badge-text">{{ShiftEnd}}</p>
                      </button>
                      <br>
                      <button class="user_badge" mat-flat-button color="accent" matBadgePosition="after"
                        matBadgeColor="accent" MatBadgeSize="large" disableRipple style="margin-left: 14px;"
                        *ngIf="Supervisor !== ''">
                        <p class="badge-text">{{Supervisor}}</p>
                      </button>
                    </div>
                  </div>

                  <br>
                </div>
              </div>
            </div>
            <div class="card-item card-item-five-group" *ngIf="showMode">
              <div class="card  card-group" *ngFor="let element of OEEInfoList" style="padding: 10px 1px;">
                <o3-percentage-graph [barProperties]="element.capacityUtilization"></o3-percentage-graph>
                <p class="graph-title" style="margin-bottom: 6px;margin-top: 10px;">OEE</p>
              </div>
            </div>
            <div class="card-item card-item-five-group" *ngIf="showMode">
              <div class="card card-group" *ngFor="let element of OEEInfoList" style="padding: 10px 1px;">
                <o3-percentage-graph [barProperties]="element.availabilityUtilization"></o3-percentage-graph>
                <p class="graph-title" style="margin-bottom: 6px;margin-top: 10px;">{{'Availability' | translate}}</p>
              </div>
            </div>
            <div class="card-item card-item-five-group" *ngIf="showMode">
              <div class="card card-group" *ngFor="let element of OEEInfoList" style="padding: 10px 1px;">
                <o3-percentage-graph [barProperties]="element.performanceUtilization"></o3-percentage-graph>
                <p class="graph-title" style="margin-bottom: 6px;margin-top: 10px;">{{'Performance' | translate}}</p>
              </div>
            </div>
            <div class="card-item card-item-five-group" *ngIf="showMode">
              <div class="card card-group" *ngFor="let element of OEEInfoList" style="padding: 10px 1px;">
                <o3-percentage-graph [barProperties]="element.qualityUtilization"></o3-percentage-graph>
                <p class="graph-title merge-style" style="margin-bottom: 6px;margin-top: 10px;">{{'Quality' |
                  translate}}</p>
              </div>
            </div>
          </div>
          <div class="" style="display: flex">
            <div class="chart-item">
              <div class="chart-title" style="text-align: center;">{{'DownTime' | translate}}Down Time (Mins)</div>
              <canvas id="downTimeChart"></canvas>
            </div>
            <div class="chart-item" style="margin-left: 100px;">
              <div class="chart-title" style="text-align: center;">{{'Weight' | translate}} (Kg)</div>
              <canvas id="weightChart"></canvas>
            </div>
          </div>

          <div class="content-row-flex-both-end">
            <!--table-->
            <table [dataSource]="lastShiftDataSource" mat-table class="basic-table basic-table1 plant-model-table"
              matSort>
              <!-- S.NoColumn -->
              <ng-container matColumnDef="sno">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">S.No</p>
                </th>
                <td mat-cell *matCellDef="let element"></td>
              </ng-container>

              <!-- Validations Column -->
              <ng-container matColumnDef="validations">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  <p class="header-text">{{'Validations' | translate}}</p>
                </th>
                <td mat-cell *matCellDef="let element"></td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="lastshiftColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: lastshiftColumns"></tr>
              <tr class="mat-row" *matNoDataRow style="text-align: center;">
                <td class="mat-cell" colspan="2">{{' NoDataFound' | translate}}</td>
              </tr>
            </table>
          </div>
          <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </mat-dialog-content>

  </ng-template>
  <ng-template #displayshiftcloseRoleModal *ngIf="onlymachineSelectProperty">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{langObj ? langObj?.Shift : ('Shift' | translate)}} {{langObj ? langObj?.Close : ('Close' | translate)}}
        </h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing "
        style="margin-left: 2px">
        <mat-label>ManPower Required</mat-label>
        <input matInput [(ngModel)]="ManPower" type="number" min="1" step="1" name="ManPower" required />
      </mat-form-field>
      <!-- <h3 style=" font-size: 20px;">{{'Availability' | translate}}</h3> -->
      <h3 style=" font-size: 20px;">{{langObj ? langObj?.Availability : ('Availability' | translate)}}</h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table mat-table class="basic-table plant-model-table" [dataSource]="availabilityDataSource" matSort>
          <!-- Start Time Column -->
          <ng-container matColumnDef="ttime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Total : ('Total' | translate)}} {{langObj ? langObj?.Time :
                ('Time' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.TotalTime}}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="dtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.DownTime : ('DownTime' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Downtime}}</td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="atime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Total : ('Total' | translate)}} {{langObj ? langObj?.Available
                : ('Available' | translate)}} {{langObj ? langObj?.Time : ('Time' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.TotalAvailableTime}}</td>
          </ng-container>

          <!-- Fault Column -->
          <ng-container matColumnDef="rtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Total : ('Total' | translate)}} {{langObj ? langObj?.Running :
                ('Running' | translate)}} {{langObj ? langObj?.Time : ('Time' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.TotalRunningTime}}</td>
          </ng-container>

          <ng-container matColumnDef="mtime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Missing : ('Missing' | translate)}} {{langObj ? langObj?.Time
                : ('Time' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.MissingTime}}</td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="availabilityColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: availabilityColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="5">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
          </tr>
        </table>
      </div>
      <h3 style=" font-size: 20px;">{{langObj ? langObj?.Performance : ('Performance' | translate)}}</h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table mat-table class="basic-table plant-model-table" [dataSource]="PerformanceDataSource" matSort>
          <!-- Start Time Column -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.ProcessOrder : ('ProcessOrder' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.ProcessOrder}}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="qty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.ProducedQuantity : ('ProducedQuantity' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.ProduceQty}}</td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="speed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.SystemSpeed : ('SystemSpeed' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.SystemSpeed}}</td>
          </ng-container>

          <!-- Fault Column -->
          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Total : ('Total' | translate)}} {{langObj ?
                langObj?.ToBeProduced : ('ToBeProduced' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.TotalTBProduce}}</td>
          </ng-container>

          <ng-container matColumnDef="diff">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Difference : ('Difference' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.Difference}}</td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="PerformanceColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: PerformanceColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="5">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
          </tr>
        </table>
      </div>
      <h3 style=" font-size: 20px;">{{langObj ? langObj?.Quality : ('Quality' | translate)}}</h3>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table mat-table class="basic-table plant-model-table" [dataSource]="qualityDataSource" matSort>
          <!-- Start Time Column -->
          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.ProcessOrder : ('ProcessOrder' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.ProcessOrder}}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="production">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Total : ('Total' | translate)}} {{langObj ?
                langObj?.Production : ('Production' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.TotalProduction}}</td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="waste">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.WasteRecorded : ('WasteRecorded' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.WasteRecorded}}</td>
          </ng-container>

          <!-- Fault Column -->
          <ng-container matColumnDef="pieces">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.GoodPieces : ('GoodPieces' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.GoodPieces}}</td>
          </ng-container>

          <ng-container matColumnDef="calculation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.AsPerCalculation : ('AsPerCalculation' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element?.AsPercalculation}}</td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="qualityColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: qualityColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="5">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
          </tr>
        </table>
      </div>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table [dataSource]="shiftDataSource" mat-table class="basic-table plant-model-table" matSort>
          <!-- Start Time Column -->
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">S.No</p>
            </th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="validation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Validation : ('Validation' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>

          <!-- Duration Column -->
          <ng-container matColumnDef="values">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{langObj ? langObj?.Values : ('Values' | translate)}}</p>
            </th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="shiftColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: shiftColumns"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="3">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
          </tr>
        </table>

      </div>
      <mat-paginator class="basic-paginataor" [pageSizeOptions]="[2, 5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
      <div style="display:flex; justify-content: flex-end;">
        <div>
          <button class="add-btn2">
            <img src="assets/images/add.png" alt="" width="20px" height="20px" (click)="shAdd()">
          </button>
        </div>
      </div>

      <div class="content-row-flex-both-end">
        <table mat-table class="basic-table plant-model-table" [dataSource]="shiftactionDataSource" matSort>
          <!-- Start Time Column -->
          <ng-container matColumnDef="sno">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">S.No</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.sno}}</td>
          </ng-container>

          <!-- End Time Column -->
          <ng-container matColumnDef="item">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.Action : ('Action' | translate) }} {{ langObj ? langObj?.Item
                : ('Item' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">
              <textarea matInput cols="40"
                [placeholder]="langObj ? langObj?.ItMakesMeFeel : ('ItMakesMeFeel' | translate)"
                (change)="shiftCloseChange($event, element)"
                style="border: 1px solid #DDD3D0; border-radius:6px;"> {{element.item}}</textarea>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="shiftactionColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: shiftactionColumns"></tr>
        </table>
      </div>
      <mat-paginator class="basic-paginataor" [pageSizeOptions]="[2, 5, 10, 20]" showFirstLastButtons>
      </mat-paginator>

    </mat-dialog-content>
    <div mat-dialog-actions style="float: right">
      <button class="add-btn2" [pTooltip]="langObj ? langObj?.Save: ('Save' | translate)" tooltipPosition="top">
        <img src="assets/images/save.png" alt="" width="20px" height="20px" (click)="SumbitShiftClose(ManPower)">
      </button>
    </div>
  </ng-template>
  <ng-template #faultmodal *ngIf="downTimeStarted">
    <form [formGroup]="downTimeForm">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{'Fault' | translate}} {{'Details' | translate}}</h2>
          <button mat-raised-button mat-dialog-close color="warn" title="close">
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <mat-dialog-content>
        <div class="content-top-row fault">
          <input formControlName="Id" [hidden]="true">
          <div class="inputField faultPop_color">
            <nz-date-picker class="calender-input sfdcCalender-input" style="background: white!important;"
              (ngModelChange)="getMinutes($event)" id="startPicker" formControlName="startDate" #ref
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }"
              [nzInputReadOnly]="true"></nz-date-picker>
            <span class="floating-text">{{'StartDate' | translate}}</span>
            <p class="invalid-feedback" *ngIf="
            downTimeForm.get('startDate')?.touched &&
            downTimeForm.get('startDate')?.hasError('required')
          ">
              * Start Date is required
            </p>
          </div>
          <div class="inputField faultPop_color">
            <nz-date-picker class="calender-clear sfdcCalender-clear" style="background: white!important;"
              (ngModelChange)="getMinutes($event)" id="endPicker" formControlName="endDate" #ref
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }"
              [nzInputReadOnly]="true"></nz-date-picker>
            <span class="floating-text">{{'EndDate' | translate}}</span>
          </div>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{'Faults' | translate}}</mat-label>
            <mat-select formControlName="fault" panelClass="testClass" name="faults">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'FaultName'" [array]="DTFaultList"
                (filteredReturn)="filteredDTFaultList = $event"></mat-select-filter>
              <mat-option *ngFor="let fault of filteredDTFaultList" [value]="fault.FaultId"> {{fault.FaultName}}
              </mat-option>
            </mat-select>
            <p class="invalid-feedback" *ngIf="
            downTimeForm.get('fault')?.touched &&
            downTimeForm.get('fault')?.hasError('required')
          ">
              * Fault is required
            </p>
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 10px">
            <mat-label>{{'Remarks' | translate}}</mat-label>
            <input formControlName="remarks" matInput name="remarks" style="color: black;" />
          </mat-form-field>
          <div>
            <button [disabled]="!downTimeForm.valid" (click)="UpdateJBDowntimeInfo(1)" type="submit" *ngIf="IsWrite"
              mat-raised-button color="primary" [pTooltip]="'Save' | translate" tooltipPosition="top"
              style="margin-left: 10px; margin-top: 5px;">
              <i class="fa fa-floppy-o" style="color: #fff"></i>
            </button>
          </div>
        </div>
        <div class="content-row-flex-both-end">
          <table mat-table [dataSource]="downtimeDataSource"
            class="fault_color basic-table basic-table1 plant-model-table" matSort>

            <ng-container matColumnDef="starttime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'StartDate' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.StartTime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <ng-container matColumnDef="endtime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'EndDate' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.EndTime | date: "dd/MM/yyyy HH:mm:ss"}}</td>
            </ng-container>

            <ng-container matColumnDef="duration">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'Duration' | translate}} (mins)</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Duration}}</td>
            </ng-container>

            <ng-container matColumnDef="fault">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'Faults' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.FaultName}}</td>
            </ng-container>

            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'Remarks' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.Remarks}}</td>
            </ng-container>


            <ng-container matColumnDef="createdon">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CreatedOn' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedOn | date: "dd/MM/yyyy hh:mm:ss"}}</td>
            </ng-container>


            <ng-container matColumnDef="createdby">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{'CreatedBy' | translate}}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element?.CreatedBy}}</td>
            </ng-container>

            <!-- userManagerActions Column -->

            <tr mat-header-row *matHeaderRowDef="downtimecolumns2"></tr>
            <tr mat-row *matRowDef="let row; columns: downtimecolumns2"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" colspan="7">{{'NoDataFound' | translate}}</td>
            </tr>
          </table>
        </div>
      </mat-dialog-content>
    </form>
  </ng-template>
  <ng-template #timermodal class="timermodal">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{'Duration of' | translate}} {{'DownTime' | translate}}</h2>
        <button mat-raised-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="d-flex align-items-center">
        <h3 class="timer_number timer_color">{{timer}}</h3>
      </div>
    </mat-dialog-content>
  </ng-template>

  <ng-template #qualityBoolListModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>{{selectionName}} Selection</h2>

        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="wrapper-box wrapper-box-shadow table-wrapper">

        <div class="content-top-row">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 55%;">
            <mat-label>Select {{selectionName}}</mat-label>
            <mat-select [(ngModel)]="qualityBoolVal">
              <mat-option *ngFor="let value of boolList" [value]="value">
                {{ value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-mini-fab mat-button color="primary" title="Save Color" style="margin-left: 10px;"
            (click)="saveBool(qualityBoolVal)">
            <i class="fa fa-floppy-o" style="color: #fff"></i>
          </button>
        </div>
      </div>
    </mat-dialog-content>
  </ng-template>
  <ng-template #qualityDateListModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>Date Selection</h2>

        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div class="content-top-row">
          <!-- <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing" style="width: 55%;">          -->
          <div class="inputField agDateColr">
            <nz-date-picker class="calender-input sfdcCalender-input" id="timePicker" [(ngModel)]="date"
              nzFormat="dd/MM/yyyy HH:mm" [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true"
              (ngModelChange)="onChange($event)">
            </nz-date-picker>
            <span class="floating-text">{{ langObj ? langObj?.Time : ('Time' | translate) }}</span>
          </div>
          <!-- </mat-form-field> -->
        </div>
      </div>
    </mat-dialog-content>
  </ng-template>

  <ng-template #materialViewModal>
    <div class="viewChecklist">
      <div mat-dialog-title>
        <div class="d-flex justify-content-between align-items-center">
          <h2>{{langObj ? langObj?.MaterialHistoryView : ('MaterialHistoryView' | translate)}}</h2>
          <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
            <i class="fa fa-times" style="color: #fff"></i>
          </button>
        </div>
      </div>
      <div class="content-row-flex-both-end">
        <!--table-->
        <table mat-table class="basic-table plant-model-table" [dataSource]="ItemBOMViewList" matSort>
          <!-- Item Type Column -->
          <ng-container matColumnDef="itemtype">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.Item : ('Item' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.ItemCode}}</td>
          </ng-container>

          <ng-container matColumnDef="itemDesc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.ItemDescription : ('ItemDescription' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.ItemDesc}}</td>
          </ng-container>
          <ng-container matColumnDef="itemuom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.Item : ('Item' | translate) }} UOM</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.UOM}}</td>
          </ng-container>

          <!-- Batch Column -->
          <ng-container matColumnDef="estQty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.EstimatedQuantity : ('EstimatedQuantity' | translate) }}</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.EsimatedQty}}</td>
          </ng-container>
          <!-- length Column -->
          <ng-container matColumnDef="actQty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.ActualQuantity : ('ActualQuantity' | translate) }} </p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.ItemBOMValue}}</td>
          </ng-container>
          <ng-container matColumnDef="traceCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">{{ langObj ? langObj?.traceCode : ('TraceCode' | translate) }} </p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.traceCode}}</td>
          </ng-container>
          <ng-container matColumnDef="kgUnit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">KG/Unit</p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.MinSkuUnit}}</td>
          </ng-container>
          <ng-container matColumnDef="NoOfDrums">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              <p class="header-text">NO Of Drums </p>
            </th>
            <td mat-cell *matCellDef="let element">{{element.NoOfDrums}}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="materialSubColumns2"></tr>
          <tr mat-row *matRowDef="let row; columns: materialSubColumns2"></tr>
          <tr class="mat-row" *matNoDataRow style="text-align: center;">
            <td class="mat-cell" colspan="8">{{langObj ? langObj?.NoDataFound : ('NoDataFound' | translate)}}</td>
          </tr>
        </table>
      </div>
    </div>
  </ng-template>
  <ng-template #displayQualityOrdersModal>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2> {{langObj? langObj?.HistoryProcessOrders: ("HistoryProcessOrders" | translate)}}</h2>

        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <div class="wrapper-box wrapper-box-shadow table-wrapper">
        <div class="d-flex justify-content-end content-top-row content-top-row-order-processing checklist_modal"
          style="margin-bottom: 0px; margin-top: -17px;">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 400px; margin-right: 0px;">
            <input matInput placeholder="Search" (keyup)="applyFilterQPO($event)" autocomplete="off" />
          </mat-form-field>
        </div>
        <div class="content-row-flex-both-end" style="margin-top: 16px;">
          <!--table-->
          <table mat-table class="basic-table plant-model-table" matSort [dataSource]="qualityProcessOrder">

            <ng-container matColumnDef="ProcessOrder">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProcessOrderNo : ("ProcessOrderNo" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.ProcessOrder}}</td>
            </ng-container>

            <ng-container matColumnDef="ProdCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProductCode : ("ProductCode" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.ProdCode}}</td>
            </ng-container>

            <ng-container matColumnDef="ProdDesc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.ProductDescription : ("ProductDescription" | translate) }}
                </p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.ProdDesc}}</td>
            </ng-container>

            <ng-container matColumnDef="StartTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.StartTime : ("StartTime" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.StartTime | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
            </ng-container>

            <ng-container matColumnDef="EndTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.EndTime : ("EndTime" | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element">{{element.EndTime | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="ordersColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: ordersColumns"></tr>
          </table>
        </div>
        <mat-paginator class="basic-paginataor" [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>

      </div>
    </mat-dialog-content>

  </ng-template>
  <ng-template #visibleYearlyTarget style="padding-bottom: 0px !important;">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>Parameter Analysis</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff;"></i>
        </button>
      </div>
      <div class="p-grid p-fluid" style="justify-content: flex-start;">
        <div class="content-top-row">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 250px">
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fromDate" placeholder="From Date" [readOnly]="true" />
              <input matEndDate formControlName="toDate" placeholder="To Date" [readOnly]="true" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="p-col-3 p-md-3" style="margin-top:15px">
          <span class="p-float-label">
            <p-multiSelect class="form-select pMultiWhite" [defaultLabel]="'Products'" inputId="multiselect"
              [options]="machineProducts" optionLabel="Prod_Desc" [filter]="true" [(ngModel)]="selectedProducts"
              selectedItemsLabel="ALL" maxSelectedLabels={{machineProducts.length-1}}>
            </p-multiSelect>
            <label for="multiselect">{{langObj ? langObj?.Products : ('Products' | translate)}} </label>
          </span>
        </div>
        <div class="p-col-3 p-md-3">
          <button
            (click)="Gridtype === 'processControl'? onChangeParamterAnalysisnProcessControl() : onChangeParamterAnalysisQualityControl()"
            mat-flat-button color="accent" type="submit" class="btn-accent">search</button>
        </div>
      </div>
    </div>
    <mat-dialog-content style="max-height:none !important">
      <div id="POClosed"></div>
      <div *ngFor="let item of chartArray">
        <div [id]="item.id" [chart]="item.chartOption"></div>
      </div>
      <!-- <div [chart]="stock"></div> -->
    </mat-dialog-content>
  </ng-template>
  <ng-template #visibleParameterComparison id="visibleParameterComparison" style="padding-top: 0px !important;">
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h2>Parameter Comparison</h2>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff;"></i>
        </button>
      </div>
      <div class="p-grid p-fluid" style="justify-content: flex-start;">
        <div class="content-top-row">
          <mat-form-field class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="width: 250px">
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker1">
              <input matStartDate formControlName="fromDate" placeholder="From Date" [readOnly]="true" />
              <input matEndDate formControlName="toDate" placeholder="To Date" [readOnly]="true" />
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-date-range-picker #picker1></mat-date-range-picker>
          </mat-form-field>
        </div>
        <div class="p-col-3 p-md-3" style="margin-top: 15px;">

          <span class="p-float-label">
            <p-multiSelect class="form-select pMultiWhite" inputId="multiselect" [options]="machineProducts"
              optionLabel="Prod_Desc" [filter]="true" [(ngModel)]="selectedProducts" selectedItemsLabel="ALL"
              maxSelectedLabels={{machineProducts.length-1}}>
            </p-multiSelect>
            <label for="multiselect">{{langObj ? langObj?.Products : ('Products' | translate)}} </label>
          </span>
        </div>
        <div class="p-col-3 p-md-3">
          <button
            (click)="Gridtype === 'processControl' ? onChangeParamterComparsionProcessControl() : onChangeParamterComparsionQualityControl()"
            mat-flat-button color="accent" type="submit" class="btn-accent">search</button>
        </div>
      </div>
    </div>
    <mat-dialog-content style="max-height:none !important">
      <div [chart]="chart"></div>
    </mat-dialog-content>
  </ng-template>

  <ng-template #imageZoomModel>
    <img src="{{currentImagePath}}" style="height: 98%;width: 100%; overflow: hidden;">
  </ng-template>

  <ng-template #imageZoomModelShow>
    <img [src]="currentImagePath" style="height: 98%; width: 100%; overflow: hidden" />
  </ng-template>

  <ng-template #ProfileImageZoomModal>
    <img [src]="currentImagePath" style="height: 100%; width: 100%; overflow: hidden" />
  </ng-template>
  <mat-form-field class="example-full-width" appearance="fill" style="display:none;">
    <mat-label>Choose a date</mat-label>
    <input matInput [matDatepicker]="pickerforprocessgrid" (dateInput)="processgridDate($event)">
    <mat-datepicker-toggle matSuffix [for]="pickerforprocessgrid"></mat-datepicker-toggle>
    <mat-datepicker touchUi #pickerforprocessgrid></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="example-full-width" appearance="fill" style="display:none;">
    <mat-label>Choose a date</mat-label>
    <input matInput [matDatepicker]="pickerforqualitygrid" (dateInput)="qualitygridDate($event)">
    <mat-datepicker-toggle matSuffix [for]="pickerforqualitygrid"></mat-datepicker-toggle>
    <mat-datepicker touchUi #pickerforqualitygrid></mat-datepicker>
  </mat-form-field>


  <ng-template #displayResponsibleModal>
    <div class="table-div">
      <table>
        <thead>
          <tr>
            <th>Responsible Users</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of AssignedUsers; let i = index;">
            <td>
              {{user.FullName}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </ng-template>


  <ng-template #displayRoleModalView>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>{{langObj ? langObj?.ChecklistExecution : ('ChecklistExecution' | translate)}}</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <div id="pdfTable" #pdfTable>
      <form [formGroup]="checklistDataFormView">
        <mat-dialog-content>
          <div class="content-top-row content-top-row-order-processing checklist_modal">


            <mat-form-field appearence="fill" class="
                top-row-first-filed-item top-row-first-filed-item-order-processing
              ">
              <mat-label class="required">{{langObj ? langObj?.ChecklistType : ('ChecklistType' |
                translate)}}</mat-label>
              <input matInput formControlName="checktype" placeholder="Enter checktype" readonly />
            </mat-form-field>
            <mat-form-field appearence="fill" class="
                top-row-first-filed-item top-row-first-filed-item-order-processing
              ">
              <mat-label class="required">{{langObj ? langObj?.ChecklistName : ('ChecklistName' |
                translate)}}</mat-label>
              <input matInput formControlName="Listname" placeholder="Enter List Name" readonly />
            </mat-form-field>
            <mat-form-field appearence="fill" class="
                top-row-first-filed-item top-row-first-filed-item-order-processing
              ">
              <mat-label class="required">{{langObj ? langObj?.Area : ('Area' | translate)}}</mat-label>
              <input matInput formControlName="area" placeholder="Enter area" readonly />
            </mat-form-field>
            <mat-form-field appearence="fill" class="
            top-row-first-filed-item top-row-first-filed-item-order-processing
          ">
              <mat-label class="required">{{langObj ? langObj?.Date : ('Date' | translate)}}</mat-label>
              <input matInput formControlName="executionDate" placeholder="Enter executionDate" readonly />
            </mat-form-field>

            <mat-form-field appearence="fill" class="
            top-row-first-filed-item top-row-first-filed-item-order-processing
          ">
              <mat-label class="required">{{langObj ? langObj?.Shift : ('Shift' | translate)}}</mat-label>
              <input matInput formControlName="shift" placeholder="Shift" [readonly]="true" />
            </mat-form-field>
          </div>
          <div class="content-top-row content-top-row-order-processing checklist_modal">
            <mat-form-field appearence="fill" class="
                top-row-first-filed-item top-row-first-filed-item-order-processing
              ">
              <mat-label>{{langObj ? langObj?.Previous : ('Previous' | translate)}} {{langObj ? langObj?.ProcessOrderNo
                :
                ('ProcessOrderNo' | translate)}}</mat-label>
              <input matInput formControlName="currentProcessOrder" placeholder="Select currentProcessOrder"
                [readonly]="true" />
            </mat-form-field>
            <mat-form-field appearence="fill" class="
            top-row-first-filed-item top-row-first-filed-item-order-processing
          ">
              <mat-label>{{langObj ? langObj?.Previous : ('Previous' | translate)}} {{langObj ? langObj?.ProductName :
                ('ProductName' | translate)}}</mat-label>
              <input matInput placeholder="Product Description" formControlName="previousProductDescription"
                [readonly]="true" />
            </mat-form-field>

          </div>
          <div class="content-top-row content-top-row-order-processing checklist_modal" *ngIf="completedRole">
            <mat-form-field *ngIf="completedRole"
              [disabled]="VerifiedStatus === 'Verified' || VerifiedStatus === 'Reject'" appearence="fill"
              class="top-row-first-filed-item top-row-first-filed-item-order-processing">
              <mat-select [disabled]="VerifiedStatus === 'Verified' || VerifiedStatus === 'Reject'"
                formControlName="con" placeholder="Confirmed" panelClass="testClass"
                (selectionChange)="rejectPopup($event)">
                <mat-option *ngFor="let confirmed of confirmedlist" [value]="confirmed.name">
                  {{ confirmed?.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-dialog-content>
        <mat-divider></mat-divider>
        <div style="margin-top: 10px"></div>
        <div class="wrapper-box wrapper-box-shadow table-wrapper" *ngIf="dataSourceView !== undefined">
          <table mat-table [dataSource]="dataSourceView" class="basic-table plant-model-table popup" matSort>
            <ng-container matColumnDef="items">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Items : ('Items' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" class="td-text">
                {{ element.ItemName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="good">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 0px; width: 12%">
                <p class="header-text">{{langObj ? langObj?.GoodExample : ('GoodExample' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10%">
                <button mat-mini-fab *ngIf="!formMode && element.GoodExampleImage!='' && element.GoodExampleImage!=null"
                  color="accent" (click)="openFilePopUpView(element , i , 1)" style="background-color: #8f0fd1;">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>

              </td>
            </ng-container>

            <ng-container matColumnDef="bad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 0px; width: 12%">
                <p class="header-text">{{langObj ? langObj?.BadExample : ('BadExample' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10%">
                <button mat-mini-fab *ngIf="!formMode && element.BadExampleImage!='' && element.BadExampleImage!=null"
                  color="accent" (click)="openFilePopUpView(element , i , 2  )" style="background-color: #8f0fd1;">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="standard">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Standard : ('Standard' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10%">
                {{ element.standard }}
              </td>
            </ng-container>

            <ng-container matColumnDef="minimum">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Min : ('Min' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 5%">
                {{ element.minValue }}
              </td>
            </ng-container>

            <ng-container matColumnDef="maximum">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Max : ('Max' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 5%">
                {{ element.maxValue }}
              </td>
            </ng-container>

            <ng-container matColumnDef="score">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 56px">
                <p class="header-text">{{langObj ? langObj?.Result : ('Result' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element;let i = index" class="td-text wrapped-text"
                style="padding-left: 80px">

                <textarea *ngIf="element.ItemTypeId === 1" class="wrapped-text" matInput [value]="element.CatType"
                  [readonly]="true"></textarea>
                <textarea *ngIf="element.ItemTypeId === 2" class="wrapped-text" matInput [value]="element.CatType"
                  [readonly]="true"></textarea>
                <input *ngIf="element.ItemTypeId === 3" matInput [value]="element.CatType | date: 'dd-MM-YYYY'"
                  [readonly]="true" />
                <img style="margin: unset;"
                  *ngIf="element.ItemTypeId === 4 && (element.typefile === 'PNG' || element.typefile === 'png' || element.typefile === 'jpg' || element.typefile === 'jpeg' || element.typefile === 'tiff' || element.typefile === 'bmp' || element.typefile === 'gif' || element.typefile === 'eps' || element.typefile === 'webp' || element.typefile === 'svg')"
                  [src]="element.CatType!== '' ?element.CatType:'assets/images/delete.png'" width="30px" height="30px"
                  (click)="imageZoomModal(element.CatType!== '' ? element.CatType:'assets/images/delete.png')">

                <textarea *ngIf="element.ItemTypeId === 5" class="wrapped-text" matInput [value]="element.CatType"
                  [readonly]="true"></textarea>

                <div
                  *ngIf="element.ItemTypeId === 4 && (element.typefile !== 'PNG' && element.typefile !== 'png' && element.typefile !== 'jpg' && element.typefile !== 'jpeg' && element.typefile !== 'tiff' && element.typefile !== 'bmp' && element.typefile !== 'gif' && element.typefile !== 'eps' && element.typefile !== 'webp' && element.typefile !== 'svg') ">
                  <button type="button" mat-mini-fab color="primary" style="margin-top: 2px;"
                    *ngIf="element.CatType != null && element.CatType != ''">
                    <a href="{{element.CatType}}">
                      <mat-icon>cloud_download</mat-icon>
                    </a>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Remarks : ('Remarks' | translate)}}</p>
              </th>

              <td mat-cell *matCellDef="let element" class="wrapped-text">
                {{element.Remarks}}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" style="text-align: center;" colspan="7">{{langObj ? langObj?.nodatamatch :
                ('nodatamatch' | translate)}}</td>
            </tr>

            <ng-container matColumnDef="groupHeader">
              <th (click)="groupHeaderClickView(group)" colspan="999" mat-header-cell *matCellDef="let group"
                class="group-header">
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="group.expanded">arrow_drop_down</mat-icon>
                  <mat-icon *ngIf="!group.expanded">arrow_right</mat-icon>
                  <span style="font-size: 20px;"
                    class="table-group-title">{{group[groupByColumns[group.level-1]]}}</span>
                </div>
              </th>
            </ng-container>
            <tr mat-header-row *matRowDef="let group; columns: ['groupHeader'];when: isGroup"></tr>
            <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"> </mat-row>
          </table>

          <!-- <mat-paginator class="basic-paginataor" [pageSizeOptions]="[5,50]" showFirstLastButtons></mat-paginator> -->
        </div>

        <div mat-dialog-actions style="float: right; margin-top: 10px">
        </div>
      </form>
    </div>
  </ng-template>



  <ng-template #changeOverCheckListExecutionModel>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h1 mat-dialog-title>{{langObj ? langObj?.ChecklistExecution : ('ChecklistExecution' | translate)}}</h1>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" title="close">
          <i class="fa fa-times" style="color: #fff"></i>
        </button>
      </div>
    </div>
    <form [formGroup]="checklistDataForm">
      <mat-dialog-content>
        <div class="content-top-row content-top-row-order-processing checklist_modal">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px;">
            <mat-label class="required">{{ langObj ? langObj?.ChecklistType : ('ChecklistType' | translate) }}
            </mat-label>
            <input matInput formControlName="checktype" placeholder="Enter List Type" readonly />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label class="required">{{ langObj ? langObj?.ChecklistName : ('ChecklistName' | translate) }}
            </mat-label>
            <input matInput formControlName="checkname" placeholder="Enter List Name" readonly />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{ langObj ? langObj?.Area : ('Area' | translate) }}</mat-label>
            <input matInput formControlName="area" placeholder="Enter area Name" readonly />
            <mat-error>{{langObj ? langObj?.PleaseSelect : ('PleaseSelect' | translate)}} {{ langObj ? langObj?.Area :
              ('Area' | translate) }}</mat-error>
          </mat-form-field>
          <div class="inputField" style="margin-top: 0px ;width: max-content;">
            <nz-date-picker (ngModelChange)="getDateShifts($event)" class="calender-input"
              formControlName="executionDate" id="timePicker1" nzFormat="dd/MM/yyyy HH:mm"
              [nzShowTime]="{ nzFormat: 'HH:mm' }" [nzInputReadOnly]="true">
            </nz-date-picker>
            <span class="floating-text">{{ langObj ? langObj?.Date : ('Date' | translate) }}</span>
          </div>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label class="required">{{langObj ? langObj?.Shift : ('Shift' | translate)}}</mat-label>
            <input matInput formControlName="shiftName" readonly />

          </mat-form-field>
          <input matInput formControlName="shift" style="display: none;" readonly placeholder="Shift" />
        </div>

        <div class="content-top-row content-top-row-order-processing checklist_modal">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px;">
            <mat-label>{{langObj ? langObj?.Previous : ('Previous' | translate)}} {{langObj ? langObj?.ProcessOrderNo :
              ('ProcessOrderNo' | translate)}}</mat-label>
            <input matInput formControlName="previousProcessOrder" [readonly]="isAuto2" />
            <input matInput formControlName="previousProcessOrderId" style="display: none;" [readonly]="isAuto2" />
          </mat-form-field>
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing">
            <mat-label>{{langObj ? langObj?.Previous : ('Previous' | translate)}} {{langObj ? langObj?.ProductName :
              ('ProductName' | translate)}}</mat-label>
            <input matInput placeholder="Product Description" formControlName="previousProductName"
              [readonly]="preAuto2" />
          </mat-form-field>
        </div>
      </mat-dialog-content>
      <div style="margin-top: 10px;"></div>
      <mat-tab-group animationDuration="0ms" #matTabId class="popup_tabs">
        <mat-tab label="Check List" style="color: #000000;">
          <table mat-table [dataSource]="checkListAddModel" class="basic-table plant-model-table popup" matSort>
            <ng-container matColumnDef="items">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Items : ('Items' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" class="td-text" style="padding-left: 80px; width: 30%;">
                {{element.itemName}}
              </td>
            </ng-container>

            <ng-container matColumnDef="good">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style=" padding-left: 0px;">
                <p class="header-text">{{langObj ? langObj?.GoodExample : ('GoodExample' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" style="width: 10%;">


                <button mat-mini-fab *ngIf="element.goodExampleImage!='' && element.goodExampleImage!=null"
                  color="accent" (click)="openFilePopUp(element , i , 1)" style="background-color: #8f0fd1;">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="bad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 0px;">
                <p class="header-text">{{langObj ? langObj?.BadExample : ('BadExample' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" style="width: 10%;">

                <button mat-mini-fab *ngIf="element.badExampleImage!='' && element.badExampleImage!=null" color="accent"
                  (click)="openFilePopUp(element , i , 2)" style="background-color: #8f0fd1;">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="standard">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">Standard</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 10%;">
                {{ element.standard }}
              </td>
            </ng-container>

            <ng-container matColumnDef="minimum">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">Min</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 5%;">
                {{ element.minValue }}
              </td>
            </ng-container>

            <ng-container matColumnDef="maximum">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">Max</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 5%;">
                {{ element.maxValue }}
              </td>
            </ng-container>

            <ng-container matColumnDef="score">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Result : ('Result' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 15%;  background-color: #edf1e5;">

                <mat-radio-group required aria-label="Select an option" [value]="element.score"
                  (change)="scoreUpdate($event, element); onChangeradio($event) " *ngIf="element.itemType === 1">
                  <mat-radio-button *ngFor="let p of categoryTypeDDL" [value]="p.id"
                    style="margin-left: 10px;">{{p.name}}
                  </mat-radio-button>
                </mat-radio-group>

                <mat-form-field appearance="fill" class="score field-fill-table " *ngIf="element.itemType === 2"
                  style="width: 180px;">
                  <input matInput autocomplete="off" (change)="scoreUpdate($event, element)" [value]="element.score">
                </mat-form-field>
                <div appearance="fill" class="field-fill" *ngIf="element.itemType === 4" style="width: 180px;">
                  <input [placeholder]="langObj ? langObj?.UploadFile : ('UploadFile' | translate)" type="file"
                    (change)="uploadedFile($event, element.checkListDetailId)" class="form-control" />

                </div>
                <mat-form-field appearence="fill" class="field-fill" *ngIf="element.itemType === 3">
                  <mat-label class="placeholder-title">{{langObj ? langObj?.FromDate : ('FromDate' | translate)}}
                  </mat-label>
                  <input matInput [matDatepicker]="pickerspoedit" (dateInput)="onDateChange($event, element)"
                    style="width: 180px;" [readonly]="true">
                  <mat-datepicker-toggle matSuffix [for]="pickerspoedit"></mat-datepicker-toggle>
                  <mat-datepicker #pickerspoedit></mat-datepicker>
                </mat-form-field>
                <mat-form-field apearence="fill" class="field-fill" *ngIf="element.itemType === 5" style="width: 100%;">

                  <mat-label>Select an option</mat-label>
                  <mat-select [value]="element.CatType" (selectionChange)="OnDropdownUpdate($event,element)">
                    <mat-option *ngFor="let data of element.dropDown"
                      [value]="data.ElementValue">{{data.ElementValue}}</mat-option>
                  </mat-select>

                </mat-form-field>
              </td>

            </ng-container>

            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{ langObj ? langObj?.Remarks: ('Remarks' | translate) }}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 50%;  background-color: #edf1e5;">
                <mat-form-field appearance="fill" class="field-fill-table" style="width: 100%;">
                  <input matInput [placeholder]="langObj ? langObj?.Remarks: ('Remarks' | translate)" autocomplete="off"
                    (change)="remarksUpdate($event, element)" [value]="element.remarks">
                </mat-form-field>
              </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="itemColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: itemColumns"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" style="text-align: center;" colspan="7">{{langObj ? langObj?.NoDataFound :
                ('NoDataFound'
                | translate)}}</td>
            </tr>


            <!-- Group header -->
            <ng-container matColumnDef="groupHeader">
              <th (click)="groupHeaderClick(group)" colspan="999" mat-header-cell *matCellDef="let group"
                class="group-header">
                <div class="d-flex align-items-center">
                  <mat-icon *ngIf="group.expanded">arrow_drop_down</mat-icon>
                  <mat-icon *ngIf="!group.expanded">arrow_right</mat-icon>
                  <span class="table-group-title">{{group[groupByColumns[group.level-1]]}}</span>
                </div>
              </th>
            </ng-container>
            <tr mat-header-row *matRowDef="let group; columns: ['groupHeader'];when: isGroup"></tr>
            <mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroup"> </mat-row>
          </table>
        </mat-tab>
        <mat-tab label="Production List">
          <table mat-table [dataSource]="changeOverProductionDataSource" class="basic-table plant-model-table popup"
            matSort>
            <ng-container matColumnDef="Product">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <!-- <p class="header-text">{{langObj ? langObj?.Product : ('Product' | translate)}}</p> -->
                <p class="header-text">Product</p>
              </th>
              <td mat-cell *matCellDef="let element" class="td-text" style=" width: 30%;">
                {{element.Prod_Desc}}
              </td>
            </ng-container>
            <ng-container matColumnDef="ItemLabel">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <!-- <p class="header-text">{{langObj ? langObj?.ItemLabel : ('ItemLabel' | translate)}}</p> -->
                <p class="header-text">Label</p>
              </th>
              <td mat-cell *matCellDef="let element" class="td-text" style="width: 30%;">
                {{element.Label}}
              </td>
            </ng-container>
            <ng-container matColumnDef="good">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style=" padding-left: 0px;">
                <p class="header-text">{{langObj ? langObj?.GoodExample : ('GoodExample' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" style="width: 10%;">


                <button mat-mini-fab *ngIf="element.goodExampleImage!='' && element.goodExampleImage!=null"
                  color="accent" (click)="openFilePopUpChangeOver(element , i , 1)" style="background-color: #8f0fd1;">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="bad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="padding-left: 0px;">
                <p class="header-text">{{langObj ? langObj?.BadExample : ('BadExample' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element; let i = index" style="width: 10%;">

                <button mat-mini-fab *ngIf="element.badExampleImage!='' && element.badExampleImage!=null" color="accent"
                  (click)="openFilePopUp(element , i , 2)" style="background-color: #8f0fd1;">
                  <mat-icon>remove_red_eye</mat-icon>
                </button>
              </td>
            </ng-container>
            <ng-container matColumnDef="result">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                <p class="header-text">{{langObj ? langObj?.Result : ('Result' | translate)}}</p>
              </th>
              <td mat-cell *matCellDef="let element" style="width: 15%;  background-color: #edf1e5;">
                <mat-radio-group required aria-label="Select an option" [value]="element.score"
                  (change)="resultUpdate($event, element.Id)">
                  <mat-radio-button [value]="true" style="margin-left: 10px;">OK
                  </mat-radio-button>
                  <mat-radio-button [value]="false" style="margin-left: 10px;">Not OK
                  </mat-radio-button>
                </mat-radio-group>

              </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="changeOverTableColumn"></tr>
            <tr mat-row *matRowDef="let row; columns: changeOverTableColumn"></tr>
            <tr class="mat-row" *matNoDataRow style="text-align: center;">
              <td class="mat-cell" style="text-align: center;" colspan="7">{{langObj ? langObj?.NoDataFound :
                ('NoDataFound'
                | translate)}}</td>
            </tr>
          </table>
        </mat-tab>
      </mat-tab-group>
    </form>
    <div mat-dialog-actions style="float: right; margin-top: 10px">
      <button mat-mini-fab mat-button color="primary" (click)="addChangeOverCheckListExecution()" *ngIf="IsWrite">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </ng-template>



  <p-dialog [closeOnEscape]="false" header="File Detail" [(visible)]="displayMaximizable" [modal]="true"
    [style]="{width: '90vw'}" [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <ngx-doc-viewer *ngIf="fileType==='doc'" [url]="doc" viewer="google"
      style="width:100%;height:90vh;margin-top:10px"></ngx-doc-viewer>
    <angular-image-viewer *ngIf="fileType==='img'" class="image-previwer-sfdc" [src]="images"
      style="width:100%;height:90vh;margin-top:10px" [(index)]="imageIndexOne"></angular-image-viewer>
  </p-dialog>


  <div style="display: none;">
    <qrcode [(qrdata)]="qrCodeData" [allowEmptyString]="true"
      [ariaLabel]="'QR Code image with the following content...'" [cssClass]="'center'" [colorDark]="'#000000ff'"
      [colorLight]="'#ffffffff'" [elementType]="'canvas'" [errorCorrectionLevel]="'M'" [imageHeight]="30"
      [imageWidth]="30" [margin]="1" [scale]="1" [title]="'QR Code'" [width]="300" (qrCodeURL)="onChangeURL($event)">
    </qrcode>
  </div>



  <ng-template #alternativeMaterialModel>
    <div mat-dialog-title>
      <div class="d-flex justify-content-between align-items-center">
        <h3>Alternative Items</h3>
        <button mat-mini-fab mat-button mat-dialog-close color="warn" pTooltip="Close" tooltipPosition="top">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <mat-dialog-content>
      <form [formGroup]="alternativeItemSearchForm">
        <div class="content-top-row content-top-row-order-processing" style="justify-content: end;">
          <mat-form-field appearence="fill" class="top-row-first-filed-item top-row-first-filed-item-order-processing"
            style="margin-left: 0px;width:30%">
            <mat-label class="required">{{ langObj ? langObj?.Search : ('Search' | translate) }}
            </mat-label>
            <input matInput id="filter-text-box-alternateItem" autocomplete="off"
              (input)="onAlternativeSearchChange()">-
          </mat-form-field>
        </div>
      </form>
      <ag-grid-angular #agGridAlternate style="width: 100%; " class="ag-theme-alpine"
        [rowData]="alternativeItemsRowData" [gridOptions]="gridOptionsCheckList" [columnDefs]="ColumnDefsAlternateItem"
        (gridReady)="onGridReadyAlternateItem($event)" [getRowStyle]="getRowStyle"
        (cellClicked)="cellClickedAlternateItemGrid($event)" [pagination]="true"
        [paginationPageSize]="10"></ag-grid-angular>
    </mat-dialog-content>
  </ng-template>

  <ng-template #QRscanner>
    <div class="d-flex justify-content-between align-items-center" style="padding-bottom:10px">
      <h2>
        {{ langObj ? langObj?.scnqrcode : ('scnqrcode' | translate) }}
      </h2>
      <button mat-mini-fab mat-dialpg-close mat-button color="warn" title="close" (click)="closeSacnnerDialoge()">
        <i class="fa fa-times" style="color: #fff"></i>
      </button>
    </div>
    <div *ngIf="scanning">
      <zxing-scanner class="scanner-div" [torch]="torchEnabled" [(device)]="currentDevice"
        (scanSuccess)="onCodeResult($event)" [formats]="formatsEnabled" [tryHarder]="tryHarder"
        (permissionResponse)="onHasPermission($event)" (camerasFound)="onCamerasFound($event)"
        (torchCompatible)="onTorchCompatible($event)"
        style="height:400px;width:400px;padding-bottom:10px"></zxing-scanner>
    </div>
  </ng-template>